import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Component,
  OnChanges,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  Input,
  SimpleChanges,
  SimpleChange
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { EventEmitter } from '@angular/core';
import saveAs from 'file-saver';
import { take } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  DocumentsType,
  ProgramTypes,
  MSSPOperatorWorkshop,
  StatusCodes,
  EnagagementTypes,
  PmoNextStepStatus,
  OpsStatus,
  PaymentProfileStatus,
  CustomerAcknowledgementDocumentStatus
} from '../../../models/_enum-collections';
import { AddEngagementType } from '../../../models/add-engagement-type.model';
import { AdditionalDocHyperLink } from '../../../models/additional-doc-hyper-link.model';
import { ApiResponse } from '../../../models/api-response.model';
import { CommonInputModel } from '../../../models/common-input.model';
import { Confidence } from '../../../models/confidence.model';
import { Constants } from '../../../models/constants.model';
import { CustomerAcknowledgement } from '../../../models/customer-ack.model';
import { CustomerModel } from '../../../models/customer.model';
import { DeclineReason } from '../../../models/decline-reason.model';
import { DocumentDeclineReason } from '../../../models/document-review.model';
import { EngagementDetails } from '../../../models/engagement-details.model';
import { EngagementEditInput } from '../../../models/engagement-edit-input.model';
import { EngagementPreviewInput } from '../../../models/engagement-preview-input.model';
import { EngagementTypeDropdown } from '../../../models/engagement-type-dropdown.model';
import { EngagementType } from '../../../models/engagement-type.model';
import { FileContentModel } from '../../../models/file-content.model';
import { L1InternalStatus } from '../../../models/l1-internal-status.model';
import { L2InternalStatus } from '../../../models/l2-internal-status.model';
import { MilestonePaymentStatus } from '../../../models/milestone-payment-status.model';
import { MonthList } from '../../../models/month-list.model';
import { NotesModel } from '../../../models/notes.model';
import { ODimIncentive } from '../../../models/o-dim-incentive.model';
import { PartnerPaymentDetails } from '../../../models/partner-payment-details.model';
import { PartnerType } from '../../../models/partner-type.model';
import { PartnerModel } from '../../../models/partner.model';
import { PmoInternalModel } from '../../../models/pmo-internal.model';
import { PmoNextStatus } from '../../../models/pmo-next-status.model';
import { PmoStatus } from '../../../models/pmo-status.model';
import { PoeDocHyperLink } from '../../../models/poe-doc-hyper-link.model';
import { PoeDocStatus } from '../../../models/poe-doc-status.model';
import { PoeInformationSurvey } from '../../../models/poe-information-survey.model';
import { PoeInformation } from '../../../models/poe-information.model';
import { PoeinvoiceStatus } from '../../../models/poe-invoice-status.model';
import { PoeStatus } from '../../../models/poe-status.model';
import { PoeSurveyResponse } from '../../../models/poe-survey-response.model';
import { PoeSurveyStatus } from '../../../models/poe-survey-status.model';
import { TaskOwner } from '../../../models/task-owner.model';
import {
  UpdateCustomerAckDocument,
  PreviewDocumentTypes
} from '../../../models/update-customer-ack-document.model';
import { UsageModel } from '../../../models/usage.model';
import { AppConstants } from '../../common/app-constants';
import { CommonService } from '../../common/common.service';
import { SettingsService } from '../../common/settings.service';
import { DashboardService } from '../../services/dashboard.service';
import { LocalStorageService } from '../../services/local-storage-service';
import { OsmosisEditService } from '../../services/osmosis-edit.service';
import { VendorService } from '../../services/vendor.service';
import { AddEngagementDetails } from '../../../models/add-engagement-details.model';
import { PoeDocument } from '../../../models/poe-document.model';
import { EngagementExtensionDetails } from '../../../models/engagement-extension-details.model';
import { CommonSharedModule } from '../../common/shared.module';
import { EngagementPreviewComponent } from '../../preview/engagement-preview/engagement-preview.component';
import { PoeSubmissionSpecialInvestmentsComponent } from './poe-submission/poe-submission-special-investments.component';
import { AppMilestone2PaymentSpecialInvestmentComponent } from './app-milestone2-payment-special-investment/app-milestone2-payment-special-investment.component';
import { AppM2PercentagePaymentSpecialInvestmentComponent } from './app-m2-percentage-payment-special-investment/app-m2-percentage-payment-special-investment.component';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    EngagementPreviewComponent,
    PoeSubmissionSpecialInvestmentsComponent,
    AppMilestone2PaymentSpecialInvestmentComponent,
    AppM2PercentagePaymentSpecialInvestmentComponent
  ]
})
export class EditComponent implements OnChanges, OnInit {
  @ViewChild('fileInputUpload', { static: true }) myfileInput!: ElementRef;
  @Output() refreshPartnerInput = new EventEmitter();
  partners!: PartnerModel[];
  addPartner!: PartnerModel;
  customers!: CustomerModel[];
  addCustomer!: CustomerModel;
  submitChangeEng!: AddEngagementType;
  pmoInternals!: PmoInternalModel[];
  addPmoInternal!: PmoInternalModel;
  appliedValue!: string;
  initialCommittedDate!: string;
  partnertypes!: PartnerType[];
  caDeclinereason!: string;
  notes!: NotesModel[];
  addNotes!: NotesModel;
  formNotes!: FormGroup;
  notesAdded = false;
  noteName!: string;
  engagementType1!: EngagementType[];
  poeStatus!: PoeStatus[];
  monthList!: MonthList[];
  confidence!: Confidence[];
  addPoeInformation!: PoeInformation;
  PoeInformation!: PoeInformation[];
  addPoeInformationSurvey!: PoeInformationSurvey;
  poeInformationSurvey!: PoeInformationSurvey[];
  cusPoeSurveyResponse!: PoeSurveyResponse[];
  parPoeSurveyResponse!: PoeSurveyResponse[];
  cusSurveyRejectionReason!: DocumentDeclineReason[];
  addEngagementDetailsDto!: AddEngagementDetails;
  addEngagementDetails!: EngagementDetails;
  EngagementDetails!: EngagementDetails[];
  addUsage!: UsageModel;
  taskOwnerDrpdwn!: TaskOwner[];
  pmoStatus!: PmoStatus[];
  pmoNextStepStatus!: PmoNextStatus[];
  ODimIncentive!: ODimIncentive[];
  l1InternalStatus1!: L1InternalStatus[];
  l2InternalStatus1!: L2InternalStatus[];
  milestonePaymentStatuses!: MilestonePaymentStatus[];
  declineReason!: DeclineReason[];
  partnerPOESurveyStatus!: PoeSurveyStatus[];
  pOEDOCstatus1!: PoeDocStatus[];
  PoeInvoiceStatus!: PoeinvoiceStatus[];
  poeDocHyperLinks!: PoeDocHyperLink[];
  additionalDocHyperLinks!: AdditionalDocHyperLink[];
  poeHistoryDocuments!: PoeDocHyperLink[];
  formEngagementDetails!: FormGroup;
  formEditChangeEng!: FormGroup;
  formPartner!: FormGroup;
  formCustomer!: FormGroup;
  formInternalPMO!: FormGroup;
  formUsageDetails!: FormGroup;
  formEngagement!: FormGroup;
  formPOEInformation!: FormGroup;
  formPOESurvey!: FormGroup;
  CustomerPOESurveyDate: any;
  PartnerPOESurveyDate: any;
  changeEngDropdown!: EngagementTypeDropdown[];
  changeEngName!: EngagementTypeDropdown[];
  changeEngType!: EngagementTypeDropdown[];
  selectedEngName: any;
  selectedEngType: any;
  apires!: ApiResponse;
  partnermsgs!: any[];
  chngmsg!: any[];
  custmsgs!: any[];
  intpmomsgs!: any[];
  isReadonlyChaneEng = true;
  isReadonlypart = true;
  isReadonlycust = true;
  isReadonlyIntPMO = true;
  isReadonlyEng = true;
  isReadonlyPOE = true;
  isReadonlyPOESurvey = true;
  isCusSurveyResponse = false;
  isParSurveyResponse = false;
  engBtnNav = false;
  partbtnNav = false;
  custbtnNav = false;
  intPMObtnNav = false;
  isReadonlyUsage = true;
  msgs!: any[];
  poecols!: any[];
  poeaddcols!: any[];
  msgsPoe!: any[];
  msgsPoeSurvey!: any[];
  msgsEngDetails!: any[];
  msgsUsageDetails!: any[];
  umsgs: any[] = [];
  isReadonly = true;
  btnNav = false;
  btnNavPoe = false;
  btnNavPoeSurvey = false;
  btnNavEngDetails = false;
  maxYearDate!: Date;

  myDate!: string;
  uname!: string;
  completed!: string[];
  active!: string[];
  approved!: string[];
  eligible!: string[];
  inEligible!: string[];
  new!: string[];
  isNoteSelected = false;
  btnDisable!: boolean;
  loadcustomAck = false;
  changeEng!: boolean;
  datePipe = new DatePipe('en-US');
  statementNumberTemp!: string;
  extendedDetail!: EngagementExtensionDetails;
  @Output() closeEditSidebar = new EventEmitter<boolean>();
  @Output() showFullscreen = new EventEmitter<boolean>();
  @Input() engagementEditInput!: EngagementEditInput;

  index!: number;
  lastIndex = -1;

  downloadSpin: boolean[] = [];
  filesUpload: any = [];
  fileUploadSpinners: boolean[] = [];
  transactionSpin!: boolean;
  uploadUrl!: string;
  loadingCount = 0;
  customerAck!: CustomerAcknowledgement[];
  partner: CustomerAcknowledgement[] = [];
  customer: CustomerAcknowledgement[] = [];
  fileNamePartCust!: string;
  submitAck!: UpdateCustomerAckDocument;
  storeCustAckFile!: CustomerAcknowledgement;
  colorLoader = true;
  fileContentModel!: FileContentModel;
  canShowPreviewModel = false;
  partnerPaymentDetails!: PartnerPaymentDetails;
  customerCountry!: string;
  partnerLocation!: string;
  engagementRequestedDate!: Date;
  isDocumentPreviewLoading = false;
  engementId!: number;
  isFullScreen!: boolean;
  isPoeInvoicePreview = false;
  invoiceDocument = 'Workshop Invoice POE Template';
  isCustomerDocumentPreview = false;
  engagementPreviewInput!: EngagementPreviewInput;
  customerAcknowledgement = 'Customer Acknowledgement';
  historyTableRow!: number;
  payeeContactName!: string;
  poeDocMaximumFiles = 1;
  docType!: number;
  customerSurveyRejectionReason!: string;
  programTypeId!: number;
  dateTime = new Date();
  yearRange = '';
  isEngagementExtendedEnable = false;
  isOptOutPartner!: boolean;
  isPartnerBlocked = false;
  partnerMpnid = 0;
  buttonClicked = false;
  isGsiWorkshop = false;
  reducedForMcap = false;
  isBusy = false;

  constructor(
    private osmEdit: OsmosisEditService,
    private ds: DashboardService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private settingsServices: SettingsService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    public localStorage: LocalStorageService,
    public paymentprofileService: VendorService
  ) {
    this.dateTime.setDate(this.dateTime.getDate());
    this.yearRange =
      (new Date().getFullYear() - 230).toString() +
      ':' +
      (new Date().getFullYear() + 250);
  }

  get release(): string {
    return environment.isProdEnvironment ? 'Prod' : 'Dev';
  }

  onFromGroup() {
    this.maxYearDate = new Date(
      new Date().setFullYear(new Date().getFullYear())
    );
    this.formEngagementDetails = this.formBuilder.group({
      engagementKey: [''],
      engagementName: [''],
      requestDate: [''],
      pMOPartnerName: [''],
      enagementTaskOwner: [''],
      enagementPMOTenantName: [''],
      enagementNextSteps: [''],
      engagementType: [''],
      engagementRequestID: [''],
      enagementStatus: ['']
    });
    this.formEngagementDetails.disable();

    this.formEditChangeEng = this.formBuilder.group({
      reqEngName: [''],
      reqEngType: ['']
    });
    this.formEditChangeEng.disable();

    this.formPartner = this.formBuilder.group({
      mPNID: [''],
      pmomPNID: [''],
      partnerName: [''],
      pmopartnerName: [''],
      partnerInputRequestorContact: [''],
      partnerInputRequestorEmail: [''],
      sSPAStatusCompliant: [''],
      partnerType: [''],
      countryName: [''],
      customerLocation: [''],
      InternalRefPartnerName: [''],
      partnerOneID: [''],
      partnerLocation: [''],
      partnerEarnedLocation: [''],
      partnerAreaLocationA14: [''],
      additionalContactEmails: ['']
    });
    this.formPartner.disable();

    this.formCustomer = this.formBuilder.group({
      tPID: [''],
      pmotPID: [''],
      tPName: [''],
      pmotPName: [''],
      customerTPIDListbasedonTenantID: [''],
      segmentGroup: [''],
      pmocustomerArea: [''],
      pmocustomerCountry: [''],
      pmousageArea: [''],
      pmousageCountry: [''],
      tenantID: [''],
      pmotenantID: [''],
      tanantName: [''],
      pmotanantName: [''],
      domainName: [''],
      pmodomainName: [''],
      tenantListbasedonTPID: ['']
    });
    this.formCustomer.disable();

    this.formInternalPMO = this.formBuilder.group({
      fullyexecutedandpaidfromtheFY19TWAProgramYN: [''],
      fullyexecutedandpaidfromtheFY19TWAProgramYNrequestIds: [''],
      fullyexecutedandpaidfromtheFY19MDAProgramYN: [''],
      fullyexecutedandpaidfromtheFY19MDAProgramYNrequestIds: [''],
      partnerRequestedsameTenantIDYN: [''],
      partnerRequestedsameTenantIDYNrequestIds: [''],
      anotherPartnerRequestedSameTenantID: [''],
      anotherPartnerRequestedSameTenantIDMpnids: [''],
      C3SWPartner: [''],
      C3TWAPartner: ['']
    });
    this.formInternalPMO.disable();

    this.formUsageDetails = this.formBuilder.group({
      usageSnapshotDate: [''],
      adjustedPCInstalledBase: [''],
      windows10MAD: [''],
      windows10MADPer: [''],
      proPlusPaidEntitlements: [''],
      proPlusActiveUsers: [''],
      proPlusActiveUsers40Per: [''],
      eXOPaidEntitlements: [''],
      eXOActiveUsers: [''],
      eXOActiveUsers25Per: [''],
      sfBPaidEntitlements: [''],
      sfBActiveUsers: [''],
      sfBActiveUsers25Per: [''],
      teamsPaidEntitlements: [''],
      teamsactiveusers: [''],
      unusedTeamsEntitlements: [''],
      teamsactiveusersPer: [''],
      rOIComputation: [''],
      spoEntitlements: [''],
      spoActiveUsers: [''],
      spoactiveusersper: [''],
      aadpQualifiedEntitlements: [''],
      aadpActiveEntitlements: [''],
      aadpaeqePercent: [''],
      teamsMeetingsQualifiedEntitlements: [''],
      teamsMeetingsActiveEntitlements: [''],
      teamsMeetingsMAUQEPercent: ['']
    });
    this.formUsageDetails.disable();

    this.formEngagement = this.formBuilder.group({
      qualifiedAmount: [''],
      taskOwner: [''],
      pMONextSteps: [''],
      incentiveApplied: [''],
      incentiveAmount: [''],
      oDimIncentive: [''],
      t1InternalStatus: [''],
      milestonePaymentStatus: [''],
      opsStatus: [''],
      declineReasons: [''],
      businessDays: [''],
      eligibleDate: [''],
      daysSinceCustomer: [''],
      thirtyDayReminderSentDate: [''],
      e30dayExpirationDate: [''],
      activityEligibilityEndDate: [''],
      committedDate: [''],
      extendedDate: [null],
      isExtended: false,
      declineEmailSent: [''],
      committedEmailSent: [''],
      daysSinceCommittedEmailSent: [''],
      reminderSentDate: [''],
      day90ExpirationDate: [''],
      daysLeftFromDay90ExpirationDate: [''],
      cancelledDate: [''],
      fundingType: [''],
      customerAckStatus: [''],
      msxid: [''],
      hasCustomerAcknowledgement: false
    });
    this.formEngagement.disable();

    this.formPOEInformation = this.formBuilder.group({
      scheduledActivityDate: [''],
      expectedPOEDate: [''],
      expectedPaymentMonth: [''],
      confidenceHighMediumLowReceived: [''],
      workshopCompletionDate: [''],
      workshopTypeCompleted: [''],
      tWACustomerSuccessSolutionPlanDateReceived: [''],
      tWAReportandRecommendationsreportDateReceived: [''],
      customerPostassessmentSurveyDateReceived: [''],
      engagementCompletionDate: [''],
      sWSecurityStrategyReportDateReceived: [''],
      partnerDeliveryContact: [''],
      partnerDeliveryContactEmail: [''],
      customerContactName: [''],
      customerContactEmail: [''],
      mSInvoiceNumber: [''],
      mSInvoicePaidDate: [''],
      paymentCentralTransactionID: [''],
      partnerPaymentProfileStatus: [''],
      supplierID: [''],
      payeeID: [''],
      payeeName: [''],
      agreement: [''],
      submittedDate: [''],
      milestoneOneCompletedDate: [''],
      partnerStatementSentDate: [''],
      statementNumber: ['']
    });
    this.formPOEInformation.disable();

    this.formPOESurvey = this.formBuilder.group({
      PoeStatus1: [''],
      poeDocumentSubmittedDate: [''],
      pOECompletionDate: [''],
      customerPOESurveyDate: [''],
      customerPOESurveyStatus: [''],
      partnerPOESurveyDate: [''],
      partnerPOESurveyStatus: [''],
      poeDOCstatusCn: [''],
      poeInvoicestatus: [''],
      customerSurveyName: [''],
      customertype: [''],
      customerSurveyCreatedDate: [''],
      partnerSurveyName: [''],
      partnerType: [''],
      partnerSurveyCreatedDate: ['']
    });
    this.formPOESurvey.disable();

    this.getDetails(this.engementId);
    this.getPartnerTypeList();
    this.ChangeEngagementTypeDropdown();
    this.getTaskOwnerList();
    this.getPmoStatusList();
    this.getODimIncentiveDropDown();
    this.getL1InternalStatusList();
    this.getMilestonePaymentStatus();
    this.getDeclineReasonList();
    this.getExpectedPaymentMonth();
    this.getConfidence();
    this.getAllEngagementType();
    this.getPOESurveyStatus();
    this.getPoeInvoiceStatusDropDown();
    this.getUploadedPOEDocs_ByEngagementId(this.engementId);
    this.getUploadedAdditionalDocs_ByEngagementId(this.engementId);
    this.getPOEDocumentHistory(this.engementId);
    this.getNotesList(this.engementId);
    this.getCusPoeSurveyResponse(this.engementId);
    this.getParPoeSurveyResponse(this.engementId);
    this.getCustomerAckFile(this.engementId);
    this.getSurveyResponseFile(this.engementId);
  }

  ngOnInit() {
    this.isFullScreen = this.localStorage.getFullscreenMode();
    this.engementId = this.engagementEditInput?.engagementId || -1;
    this.historyTableRow = AppConstants.historyTableRow;
    this.isOptOutPartner = this.engagementEditInput?.isOptOutPartner || false;
    this.colorLoader = true;
    this.isPartnerBlocked = false;

    this.poecols = [
      { field: 'poeDocName', header: 'Document Name' },
      { field: 'status', header: 'Status' },
      { field: 'uploadDate', header: 'Upload Date' }
    ];

    this.poeaddcols = [
      { field: 'addnlDocName', header: 'Document Name' },
      { field: 'uploadDate', header: 'Upload Date' }
    ];

    this.onFromGroup();

    this.formNotes = this.formBuilder.group({
      notes: ['']
    });
  }

  uploadFile(event) {
    const files = event.files;
    if (
      this.docType === DocumentsType.POEInvoice ||
      this.docType === DocumentsType.POEDocument
    ) {
      this.uploadPOEDocumentToBlob(files);
    } else {
      for (const fileUpload of files) {
        const ext = fileUpload.name.substring(
          fileUpload.name.lastIndexOf('.') + 1
        );
        if (
          ext.toLowerCase() === 'pdf' ||
          ext.toLowerCase() === 'jpeg' ||
          ext.toLowerCase() === 'png' ||
          ext.toLowerCase() === 'jpg' ||
          ext.toLowerCase() === 'bmp' ||
          ext.toLowerCase() === 'gif'
        ) {
          if (fileUpload.size > 10485760) {
            this.umsgs.push({
              severity: 'error',
              detail: fileUpload.name + 'files is greater than 10 Mb'
            });
            setTimeout(() => {
              this.umsgs = [];
            }, 6000);
          } else {
            const formData = new FormData();
            formData.append('file', fileUpload, fileUpload.name);
            const newFile = {
              fileName: fileUpload.name,
              size: fileUpload.size
            };
            if (
              this.filesUpload.find(
                (a: { fileName: any }) => a.fileName === newFile.fileName
              ) === undefined
            ) {
              if (
                this.filesUpload.length === 0 ||
                this.filesUpload.length !== 1
              ) {
                this.filesUpload.push(newFile);
                this.fileUploadSpinners.push(true);
                this.fileuploding(formData);
                this.transactionSpin = true;
              } else {
                this.umsgs = [];
                this.umsgs.push({
                  severity: 'error',
                  detail: 'Possible upload only one file in list'
                });
                setTimeout(() => {
                  this.umsgs = [];
                }, 6000);
              }
            } else {
              this.umsgs = [];
              this.umsgs.push({
                severity: 'error',
                detail: fileUpload.name + ' file already exits in list'
              });
              setTimeout(() => {
                this.umsgs = [];
              }, 6000);
            }
          }
        } else {
          this.umsgs.push({
            severity: 'error',
            detail: 'Image or Pdf file Accepetable'
          });
          setTimeout(() => {
            this.umsgs = [];
          }, 6000);
        }
      }
      this.myfileInput.nativeElement.value = '';
    }
  }
  getSurveyResponseFile(eng) {
    this.osmEdit
      .getSurveyResponseFile(eng, 'Customer')
      .subscribe(downloadReport => {
        this.customer = downloadReport;
      });
    this.osmEdit
      .getSurveyResponseFile(eng, 'Partner')
      .subscribe(downloadReport => {
        this.partner = downloadReport;
      });
  }

  cusSurveyResponseDownload(fille: string) {
    if (fille === 'Customer') {
      if (this.customer.length === 0) {
        this.msgsPoeSurvey = [];
        this.msgsPoeSurvey.push({
          severity: 'error',
          detail: 'Customer Survey Response File is not available'
        });
        return;
      } else {
        this.fileNamePartCust = this.customer[0].fileName || '';
      }
    } else {
      if (this.partner.length === 0) {
        this.msgsPoeSurvey = [];
        this.msgsPoeSurvey.push({
          severity: 'error',
          detail: 'Partner Survey Response File is not available'
        });
        return;
      } else {
        this.fileNamePartCust = this.partner[0].fileName || '';
      }
    }

    const headers = new HttpHeaders();
    const downloadUrl =
      this.settingsServices.baseUrl +
      'api/PoeInformation/DownloadSurveyResponseFile/' +
      this.engementId +
      '/' +
      fille +
      '/' +
      this.fileNamePartCust;

    this.http
      .get(downloadUrl, {
        headers,
        responseType: 'blob'
      })
      .subscribe(downloadFile => {
        const file = new Blob([downloadFile], {
          type: 'application/octet-stream'
        });
        saveAs(file, this.fileNamePartCust);
      });
  }

  fileuploding(formData: any) {
    this.uploadUrl =
      this.settingsServices.baseUrl +
      'api/EngagementDetails/InsertMultipleFile/' +
      this.engementId;
    this.http
      .post<CustomerAcknowledgement[]>(this.uploadUrl, formData)
      .subscribe(
        (efRes: any) => {
          this.storeCustAckFile = efRes;
          const finalFile = this.filesUpload.find(
            a => a.fileName === efRes.fileName
          );
          const idx = this.filesUpload.indexOf(finalFile);
          this.fileUploadSpinners[idx] = false;
          if (++this.loadingCount === this.filesUpload.length) {
            this.transactionSpin = false;
          }
          this.getCustomerAckFile(this.engementId);
        },
        error => {
          this.umsgs = [];
          if (error.status === 500) {
            this.umsgs.push({ severity: 'error', detail: error.statusText });
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          } else if (error.status === 502) {
            this.umsgs.push({ severity: 'error', detail: error.statusText });
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          } else {
            this.umsgs.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while uploading a file'
            });
            this.filesUpload = [];
            this.fileUploadSpinners = [];
            this.transactionSpin = false;
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          }
        }
      );
  }
  submitCustomerAckFile() {
    if (this.storeCustAckFile === undefined || this.storeCustAckFile === null) {
      this.umsgs = [];
      const noFileError =
        this.docType === DocumentsType.POEInvoice ||
        this.docType === DocumentsType.POEDocument
          ? 'Upload POE Document to submit'
          : 'Upload Customer Acknowledgement file to Submit';
      this.umsgs.push({ severity: 'error', detail: noFileError });
      setTimeout(() => {
        this.umsgs = [];
      }, 4000);
    } else {
      if (
        this.docType === DocumentsType.POEInvoice ||
        this.docType === DocumentsType.POEDocument
      ) {
        this.submitUploadedPOEDocuments();
      } else {
        this.submitAck = {
          engagementId: this.engementId,
          fileName: this.storeCustAckFile.fileName,
          fileURL: this.storeCustAckFile.url
        };

        this.osmEdit.submitCustomerAck(this.submitAck).subscribe(
          messageResponse => {
            this.apires = messageResponse;
            if (this.apires.success === true) {
              this.storeCustAckFile = {};
              this.refreshPartnerInput.emit();
              this.umsgs = [];
              this.umsgs.push({
                severity: 'success',
                detail: this.apires.message
              });
              setTimeout(() => {
                this.refreshAllTab();
                this.umsgs = [];
              }, 4000);
            }
            if (this.apires.success === false) {
              this.umsgs = [];
              this.umsgs.push({
                severity: 'error',
                detail: this.apires.errorMessages
                  ? this.apires.errorMessages[0]
                  : 'Unknown error'
              });
              setTimeout(() => {
                this.umsgs = [];
              }, 4000);
            }
          },
          error => {
            if (error.status === 500) {
              this.umsgs = [];
              this.umsgs.push({ severity: 'error', detail: error.error });
              setTimeout(() => {
                this.umsgs = [];
              }, 2000);
            } else {
              this.umsgs.push({
                severity: 'warn',
                detail: 'Sorry an Error Occured while Changing Engagement'
              });
            }
          }
        );
      }
    }
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  deleteAttachmentNewFile(index) {
    const a = this.filesUpload.splice(index, 1);
    this.fileUploadSpinners.splice(index, 1);
    --this.loadingCount;
    const fileName = a[0].fileName;
    if (fileName) {
      this.osmEdit
        .deleteCustomerAcknowledgementFile(this.engementId, fileName)
        .subscribe(() => {
          this.getCustomerAckFile(this.engementId);
        });
    }
  }
  deleteAttachment(index) {
    const a = this.customerAck.splice(index, 1);
    this.downloadSpin.splice(index, 1);
    if (this.filesUpload.length > 0) {
      for (let i = 0; i < this.filesUpload.length; i++) {
        if (this.filesUpload[i].fileName === a[0].fileName) {
          this.filesUpload.splice(i, 1);
          this.fileUploadSpinners.splice(i, 1);
          --this.loadingCount;
        }
      }
    }
    const fileName = a[0].fileName;
    if (fileName) {
      this.osmEdit
        .deleteCustomerAcknowledgementFile(this.engementId, fileName)
        .subscribe(() => {
          this.getCustomerAckFile(this.engementId);
        });
    }
  }

  uploadOpenNav() {
    this.loadcustomAck = true;
    this.docType = DocumentsType.CustomerAcknowledgement;
  }

  cancelCustomAckNav() {
    this.loadcustomAck = false;
    this.clearHtmlFileInput();
    this.storeCustAckFile = {};
    this.filesUpload = [];
  }

  showFullScreen(isFullScreen: boolean) {
    this.isFullScreen = isFullScreen;
    this.localStorage.setFullscreenMode(this.isFullScreen);
    this.showFullscreen.emit(this.isFullScreen);
  }

  canShowPreviewButton(fileName: string) {
    const extensions: string[] = [
      '.pdf',
      '.jpeg',
      '.png',
      '.jpg',
      '.bmp',
      '.gif'
    ];
    return extensions.some(v => fileName.toLowerCase().endsWith(v));
  }

  closePreview() {
    this.canShowPreviewModel = false;
    this.isPoeInvoicePreview = false;
    this.isCustomerDocumentPreview = false;
    this.engagementPreviewInput = {
      engagementId: 0,
      previewFileIndex: 0,
      isPoePreview: false,
      isCustomerAckApproval: false,
      documentType: '',
      customerSurveyResponse: [],
      isHistoryDocument: false,
      documentTypeId: 0
    };
  }

  canSelectStatusCode(statusCode) {
    if (
      (this.programTypeId === ProgramTypes.MSSP &&
        this.formEngagementDetails.value.engagementType ==
          MSSPOperatorWorkshop.MSSP_SecurityRFP) ||
      (this.programTypeId === ProgramTypes.Operator &&
        this.formEngagementDetails.value.engagementType ==
          MSSPOperatorWorkshop.DealAssociation)
    ) {
      if (
        statusCode == StatusCodes.Ready_For_Payment ||
        statusCode == StatusCodes.Submit_In_PC ||
        statusCode == StatusCodes.Process_For_Payment
      ) {
        this.SetPreviousDropdownValue(this.engementId);
        this.msgsEngDetails = [];
        this.msgsEngDetails.push({
          severity: 'error',
          detail:
            '"' +
            statusCode +
            '" is not valid for MSSP > RFP or Operator > Deal Association engagements"'
        });
        return false;
      }
    } else {
      if (
        statusCode == StatusCodes.POE_Complete_For_Milestone1 ||
        statusCode == StatusCodes.Qualified_For_Milestone2 ||
        statusCode == StatusCodes.Waiting_For_Milestone2_Eligibility
      ) {
        this.SetPreviousDropdownValue(this.engementId);
        this.msgsEngDetails = [];
        this.msgsEngDetails.push({
          severity: 'error',
          detail:
            '"' +
            statusCode +
            '" is only valid for MSSP > RFP or Operator > Deal Association engagements"'
        });
        return false;
      }
    }

    return true;
  }

  onPmoNextStepStatusChange(event) {
    this.msgsEngDetails = [];
    if (
      event.value.pmoNextStepName ==
        StatusCodes.Waiting_For_Milestone2_Eligibility ||
      event.value.pmoNextStepName == StatusCodes.Process_For_Payment
    ) {
      this.canSelectStatusCode(event.value.pmoNextStepName);
    }
  }
  onOpsStatusChange(event) {
    this.msgsEngDetails = [];
    if (
      event.value.l2internalStatus == StatusCodes.POE_Complete_For_Milestone1 ||
      event.value.l2internalStatus == StatusCodes.Submit_In_PC
    ) {
      this.canSelectStatusCode(event.value.l2internalStatus);
    }
  }

  onL1InternalStatusChange(event) {
    this.msgsEngDetails = [];
    if (
      event.value.l1internalStatus == StatusCodes.Qualified_For_Milestone2 ||
      event.value.l1internalStatus == StatusCodes.Ready_For_Payment
    ) {
      if (!this.canSelectStatusCode(event.value.l1internalStatus)) return;
    }

    let committedDate = this.datePipe.transform(
      this.formEngagement.controls['committedDate'].value,
      'MM/dd/yyyy'
    );
    if (event.value.l1internalStatus === 'Committed' && !committedDate) {
      committedDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy');
      this.formEngagement.controls['committedDate'].setValue(committedDate);
    } else if (!committedDate) {
      this.formEngagement.controls['committedDate'].setValue(
        this.initialCommittedDate
      );
    }
  }

  previewFile(index) {
    this.engagementPreviewInput = {
      engagementId: this.engementId,
      previewFileIndex: index,
      isPoePreview: false,
      isCustomerAckApproval: false,
      documentType: '',
      customerSurveyResponse: [],
      isHistoryDocument: false,
      documentTypeId: 0
    };
    this.canShowPreviewModel = true;
  }

  transformURL(url: string): any {
    if (!url) {
      return null;
    }
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
  canShowInvoicePreview(filePath: string) {
    const fileExtension = filePath
      ?.split('/')[5]
      ?.split('?')[0]
      ?.trim()
      ?.split('.')
      ?.pop()
      ?.toLowerCase();

    const extensions: string[] = [
      'pdf',
      'jpeg',
      'png',
      'jpg',
      'bmp',
      'gif',
      'doc',
      'docx',
      'ppt',
      'pptx'
    ];
    return extensions.some(v => v === fileExtension);
  }

  previewInvoice(invoiceFile: PoeDocHyperLink) {
    this.engagementPreviewInput = {
      engagementId: this.engementId,
      previewFileIndex: 1,
      isPoePreview: true,
      isCustomerAckApproval: false,
      documentType: '',
      customerSurveyResponse: [],
      isHistoryDocument: false,
      documentTypeId: 0,
      invoiceFile: invoiceFile
    };

    if (invoiceFile.poeDocName === this.invoiceDocument) {
      this.engagementPreviewInput.documentType =
        PreviewDocumentTypes.poeinvoice;
    } else {
      this.engagementPreviewInput.documentType =
        PreviewDocumentTypes.poedocument;
    }
  }

  previewAdditionalDocument(file: AdditionalDocHyperLink) {
    this.engagementPreviewInput = {
      documentType: PreviewDocumentTypes.additionalDocument,
      isPoePreview: (this.isPoeInvoicePreview = false),
      engagementId: this.engementId,
      previewFileIndex: 1,
      additionalDoc: file,
      isCustomerAckApproval: false,
      customerSurveyResponse: [],
      isHistoryDocument: false,
      documentTypeId: 0
    };

    this.canShowPreviewModel = true;
  }

  previewHistoryDocument(file: PoeDocHyperLink) {
    this.engagementPreviewInput = {
      isPoePreview: (this.isPoeInvoicePreview = false),
      engagementId: this.engementId,
      previewFileIndex: 1,
      invoiceFile: file,
      isCustomerAckApproval: false,
      customerSurveyResponse: [],
      isHistoryDocument: true,
      documentTypeId: 0,
      documentType: ''
    };

    this.canShowPreviewModel = true;
  }

  downloadFile(index) {
    this.downloadSpin[index] = true;

    const downloadAcknowledgementInputModel: UpdateCustomerAckDocument = {
      engagementId: this.engementId,
      fileName: this.customerAck[index].fileName,
      documentType: this.customerAcknowledgement
    };

    this.ds
      .getFileSasUrl(downloadAcknowledgementInputModel)
      .subscribe(downloadFileSasUrl => {
        setTimeout(() => {
          const custAck = this.customerAck.find(
            itm => itm.fileName === this.customerAck[index].fileName
          );
          const idx = custAck ? this.customerAck.indexOf(custAck) : -1;
          this.downloadSpin[idx] = false;
        }, 5000);
        window.location.href = downloadFileSasUrl;
      });
  }

  downloadPOE(downloadPOE: PoeDocHyperLink) {
    this.downloadSpin[0] = true;

    const downloadAcknowledgementInputModel: UpdateCustomerAckDocument = {
      fileName: downloadPOE.fileName,
      engagementId: this.engementId
    };

    this.ds
      .getFileSasUrl(downloadAcknowledgementInputModel)
      .subscribe(downloadFileSasUrl => {
        window.location.href = downloadFileSasUrl;
      });
  }

  downloadCustackemtem() {
    const headers = new HttpHeaders();
    const downloadUrl =
      this.settingsServices.baseUrl + 'api/EngagementDetails/DownloadOFTFile';

    this.http
      .get(downloadUrl, {
        headers,
        responseType: 'blob'
      })
      .subscribe(downloadFile => {
        const file = new Blob([downloadFile], {
          type: 'application/octet-stream'
        });
        saveAs(file, 'Customer Acknowledgement Email Template.oft');
      });
  }

  getCustomerAckFile(id): void {
    this.osmEdit.getCustomerAcknowledgementFile(id).subscribe(imglist => {
      this.customerAck = imglist;
      this.downloadSpin = this.customerAck.map(() => false);
    });
  }

  onSubmitChangeEng() {
    this.submitChangeEng = {
      engagementId: this.engementId,
      userId: this.settingsServices.AliasName || undefined,
      engagementName: '',
      engagementSubType: ''
    };

    if (this.selectedEngType === null) {
      this.chngmsg = [];
      this.chngmsg.push({
        severity: 'error',
        detail: 'Select Engagement Type'
      });
      setTimeout(() => {
        this.chngmsg = [];
      }, 2000);
      return;
    }

    this.submitChangeEng.engagementName =
      this.formEngagementDetails.controls['engagementName'].value;
    this.submitChangeEng.engagementSubType =
      this.selectedEngType.engagementType;

    this.osmEdit.submitChangeEngagementType(this.submitChangeEng).subscribe(
      msg => {
        this.apires = msg;
        if (this.apires.success === true) {
          this.refreshPartnerInput.emit();
          this.chngmsg = [];
          this.chngmsg.push({
            severity: 'success',
            detail: 'Engagement Saved Successfully.'
          });
          this.btnDisable = true;
          this.partbtnNav = false;
          this.formPartner.disable();
          setTimeout(() => {
            this.chngmsg = [];
          }, 2000);
        }
      },
      error => {
        if (error.status === 500) {
          this.chngmsg = [];
          this.chngmsg.push({ severity: 'error', detail: error.error });
          setTimeout(() => {
            this.chngmsg = [];
          }, 2000);
        } else {
          this.chngmsg.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured while Changing Engagement'
          });
        }
      }
    );
  }

  onSubmitNotes() {
    this.noteName = this.settingsServices.AliasName || '';
    this.addNotes = {
      requestDetailId: this.engementId,
      userAlias: this.noteName,
      notes: this.formNotes.controls['notes'].value
    };

    this.osmEdit.addNotes(this.addNotes).subscribe(messageResponse => {
      this.apires = messageResponse;
      this.refreshNotes();
    });
    this.formNotes.controls['notes'].setValue('');
  }

  getNotesList(reqId: number): void {
    this.osmEdit.getNotes(reqId).subscribe(noteslistService => {
      this.notes = noteslistService;
    });
  }

  refreshNotes() {
    this.getNotesList(this.engementId);
  }

  fillEditValues(engementId: number) {
    this.isFullScreen = this.localStorage.getFullscreenMode();
    this.engementId = this.engagementEditInput?.engagementId || -1;
    this.isOptOutPartner = this.engagementEditInput?.isOptOutPartner || false;
    this.getPartnerTypeList();
    this.ChangeEngagementTypeDropdown();
    this.getTaskOwnerList();
    this.getPmoStatusList();
    this.getODimIncentiveDropDown();
    this.getL1InternalStatusList();
    this.getMilestonePaymentStatus();
    this.getDeclineReasonList();
    this.getExpectedPaymentMonth();
    this.getConfidence();
    this.getPOESurveyStatus();
    this.getPoeInvoiceStatusDropDown();
    this.getDetails(engementId);
    this.getUploadedPOEDocs_ByEngagementId(engementId);
    this.getUploadedAdditionalDocs_ByEngagementId(engementId);
    this.getPOEDocumentHistory(this.engementId);
    this.getNotesList(engementId);
    this.getCusPoeSurveyResponse(engementId);
    this.getParPoeSurveyResponse(engementId);
    this.getCustomerAckFile(engementId);
    this.getSurveyResponseFile(engementId);
  }

  ngOnChanges(changes: SimpleChanges) {
    const engId: SimpleChange = changes['engementId'];

    if (engId !== undefined) {
      if (
        engId !== undefined &&
        engId.previousValue !== engId.currentValue &&
        engId.previousValue !== undefined
      ) {
        this.colorLoader = true;
        this.onFromGroup();
      }
    }
  }

  onSubmitPartner() {
    this.addPartner = {
      requestDetailId: this.engementId,
      partnerInputMpnid: this.formPartner.controls['mPNID'].value,
      pmoconfirmedPartnerMpnid: this.formPartner.controls['pmomPNID'].value,
      partnerInputPartnerName: this.formPartner.controls['partnerName'].value,
      pmoconfirmedPartnerName:
        this.formPartner.controls['pmopartnerName'].value,
      partnerInputRequestorContact:
        this.formPartner.controls['partnerInputRequestorContact'].value,
      partnerInputRequestorEmail:
        this.formPartner.controls['partnerInputRequestorEmail'].value,
      sspastatusCompliant:
        this.formPartner.controls['sSPAStatusCompliant'].value,
      partnerTypeId:
        this.formPartner.controls['partnerType'].value.partnerTypeId,
      partnerTypeIdName:
        this.formPartner.controls['partnerType'].value.partnerType,
      partnerName: this.formPartner.controls['InternalRefPartnerName'].value,
      partnerOneId: this.formPartner.controls['partnerOneID'].value,
      partnerLocation: this.formPartner.controls['partnerLocation'].value,
      partnerEarnedLocation:
        this.formPartner.controls['partnerEarnedLocation'].value,
      partnerAreaLocationA14:
        this.formPartner.controls['partnerAreaLocationA14'].value,
      additionalContactEmails:
        this.formPartner.controls['additionalContactEmails'].value,
      lastUserAlias: this.uname
    };

    this.uname = this.settingsServices.AliasName || '';

    this.osmEdit.addCsiPartner(this.addPartner).subscribe(
      messageResponse => {
        this.apires = messageResponse;
        if (this.apires.success === true) {
          this.refreshPartnerInput.emit();
          this.partnermsgs = [];
          this.partnermsgs.push({
            severity: 'success',
            detail: 'Records Saved Successfully.'
          });
          this.formEngagementDetails.controls['pMOPartnerName'].setValue(
            this.formPartner.controls['pmopartnerName'].value
          );
          this.partbtnNav = false;
          this.formPartner.disable();
        }
        if (this.apires.success === false) {
          this.partnermsgs = [];
          this.partnermsgs.push({
            severity: 'error',
            detail: this.apires.errorMessages?.[0]
          });
        }
      },
      error => {
        this.partnermsgs = [];
        let errors: string[] = [];
        if (error.status === 400) {
          errors = this.commonService.getBadRequestErrors(error);
          for (const msg of errors) {
            this.partnermsgs.push({ severity: 'warn', detail: msg });
          }
        } else {
          this.partnermsgs.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured while Adding Partner Details'
          });
        }
      }
    );
  }

  onSelectMethod(event) {
    const pipe = new DatePipe('en-US');
    const d = new Date(Date.parse(event));

    this.myDate = pipe.transform(d, 'M/d/yyyy') || '';
  }

  onSubmitCustomer() {
    this.addCustomer = {
      requestDetailId: this.engementId,
      partnerInputCustomerTpid: this.formCustomer.controls['tPID'].value,
      pmoconfirmedCustomerTpid: this.formCustomer.controls['pmotPID'].value,
      partnerInputTenantName: this.formCustomer.controls['tPName'].value,
      pmoconfimedTopParentCustomerName:
        this.formCustomer.controls['pmotPName'].value,
      customerTpidlist:
        this.formCustomer.controls['customerTPIDListbasedonTenantID'].value,
      segmentGroup: this.formCustomer.controls['segmentGroup'].value,
      pmoconfirmedTopParentCustomerArea:
        this.formCustomer.controls['pmocustomerArea'].value,
      pmoconfirmedTopParentCustomerCountry:
        this.formCustomer.controls['pmocustomerCountry'].value,
      pmoconfirmedUsageArea: this.formCustomer.controls['pmousageArea'].value,
      pmoconfirmedUsageCountry:
        this.formCustomer.controls['pmousageCountry'].value,
      partnerInputTenantId: this.formCustomer.controls['tenantID'].value,
      pmoconfirmedTenantId: this.formCustomer.controls['pmotenantID'].value,
      partnerInputCustomerName: this.formCustomer.controls['tanantName'].value,
      pmoconfirmedTenantName: this.formCustomer.controls['pmotanantName'].value,
      partnerInputDomainName: this.formCustomer.controls['domainName'].value,
      pmoconfirmedDomainName: this.formCustomer.controls['pmodomainName'].value,
      tenantListbasedonTpid:
        this.formCustomer.controls['tenantListbasedonTPID'].value
    };

    this.uname = this.settingsServices.AliasName || '';
    this.addCustomer.lastUserAlias =
      this.uname !== '' && this.uname !== '' && this.uname != null
        ? this.uname
        : '';

    this.osmEdit.addCustomer(this.addCustomer).subscribe(
      messageResponse => {
        this.apires = messageResponse;
        if (this.apires.success === true) {
          this.refreshPartnerInput.emit();
          this.custmsgs = [];
          this.custmsgs.push({
            severity: 'success',
            detail: 'Records Saved Successfully.'
          });
          this.formEngagementDetails.controls[
            'enagementPMOTenantName'
          ].setValue(this.formCustomer.controls['pmotanantName'].value);
          this.isReadonlycust = true;
          this.custbtnNav = false;
          this.formCustomer.disable();
        }
        if (this.apires.success === false) {
          this.custmsgs = [];
          this.custmsgs.push({
            severity: 'error',
            detail: this.apires.errorMessages
              ? this.apires.errorMessages[0]
              : 'Unknown error'
          });
        }
      },
      error => {
        this.custmsgs = [];
        let errors: string[] = [];
        if (error.status === 400) {
          errors = this.commonService.getBadRequestErrors(error);
          for (const msg of errors) {
            this.custmsgs.push({ severity: 'warn', detail: msg });
          }
        } else {
          this.custmsgs.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured while Adding Partner Details'
          });
        }
      }
    );
  }

  onSubmitInternalPMO() {
    this.uname = this.settingsServices.AliasName || '';

    this.addPmoInternal = {
      requestDetailId: this.engementId,
      fullyExecutedAndPaidFromTheFy19twaprogramYnfy19paidTwa:
        this.formInternalPMO.controls[
          'fullyexecutedandpaidfromtheFY19TWAProgramYN'
        ].value,
      fullyExecutedAndPaidFromTheFy19twaprogramYnfy19paidTwarequestIds:
        this.formInternalPMO.controls[
          'fullyexecutedandpaidfromtheFY19TWAProgramYNrequestIds'
        ].value,
      fullyExecutedAndPaidFromTheFy19mdaprogramYnfy19paidMda:
        this.formInternalPMO.controls[
          'fullyexecutedandpaidfromtheFY19MDAProgramYN'
        ].value,
      fullyExecutedAndPaidFromTheFy19mdaprogramYnfy19paidMdarequestIds:
        this.formInternalPMO.controls[
          'fullyexecutedandpaidfromtheFY19MDAProgramYNrequestIds'
        ].value,
      partnerRequestedSameTenantIdynduplicateTenantFromSamePartner:
        this.formInternalPMO.controls['partnerRequestedsameTenantIDYN'].value,
      partnerRequestedSameTenantIdynduplicateTenantFromSamePartnerRequestIds:
        this.formInternalPMO.controls[
          'partnerRequestedsameTenantIDYNrequestIds'
        ].value,
      anotherPartnerRequestedSameTenantIdynduplicateTenantFromAnotherPartner:
        this.formInternalPMO.controls['anotherPartnerRequestedSameTenantID']
          .value,
      anotherPartnerRequestedSameTenantIdynduplicateTenantFromAnotherPartnerMpnids:
        this.formInternalPMO.controls[
          'anotherPartnerRequestedSameTenantIDMpnids'
        ].value,
      c3customerYn: this.formInternalPMO.controls['C3SWPartner'].value,
      c3TWAPartnerYN: this.formInternalPMO.controls['C3TWAPartner'].value,
      lastUserAlias: this.uname
    };

    this.osmEdit.addPmoInternal(this.addPmoInternal).subscribe(
      messageResponse => {
        this.apires = messageResponse;
        if (this.apires.success === true) {
          this.refreshPartnerInput.emit();
          this.intpmomsgs = [];
          this.intpmomsgs.push({
            severity: 'success',
            detail: 'Records Saved Successfully.'
          });
          this.isReadonlyIntPMO = true;
          this.intPMObtnNav = false;
          this.formInternalPMO.disable();
        }
        if (this.apires.success === false) {
          this.intpmomsgs = [];
          this.intpmomsgs.push({
            severity: 'error',
            detail: this.apires.errorMessages
              ? this.apires.errorMessages[0]
              : 'Unknown error'
          });
        }
      },
      error => {
        this.intpmomsgs = [];
        let errors: string[] = [];
        if (error.status === 400) {
          errors = this.commonService.getBadRequestErrors(error);
          for (const msg of errors) {
            this.intpmomsgs.push({ severity: 'warn', detail: msg });
          }
        } else {
          this.intpmomsgs.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured while Adding Partner Details'
          });
        }
      }
    );
  }

  onSubmitPOEInformation() {
    this.buttonClicked = true;
    const datePipe = new DatePipe('en-US');
    const scheduledActivityDate = datePipe.transform(
      this.formPOEInformation.controls['scheduledActivityDate'].value,
      'MM/dd/yyyy'
    );

    const expectedPOEDate = datePipe.transform(
      this.formPOEInformation.controls['expectedPOEDate'].value,
      'MM/dd/yyyy'
    );

    const workshopCompletionDate = datePipe.transform(
      this.formPOEInformation.controls['workshopCompletionDate'].value,
      'MM/dd/yyyy'
    );

    const tWACustomerSuccessSolutionPlanDateReceived = datePipe.transform(
      this.formPOEInformation.controls[
        'tWACustomerSuccessSolutionPlanDateReceived'
      ].value,
      'MM/dd/yyyy'
    );

    const tWAReportandRecommendationsreportDateReceived = datePipe.transform(
      this.formPOEInformation.controls[
        'tWAReportandRecommendationsreportDateReceived'
      ].value,
      'MM/dd/yyyy'
    );

    const customerPostassessmentSurveyDateReceived = datePipe.transform(
      this.formPOEInformation.controls[
        'customerPostassessmentSurveyDateReceived'
      ].value,
      'MM/dd/yyyy'
    );

    const engagementCompletionDate = datePipe.transform(
      this.formPOEInformation.controls['engagementCompletionDate'].value,
      'MM/dd/yyyy'
    );

    const sWSecurityStrategyReportDateReceived = datePipe.transform(
      this.formPOEInformation.controls['sWSecurityStrategyReportDateReceived']
        .value,
      'MM/dd/yyyy'
    );

    const mSInvoicePaidDate = datePipe.transform(
      this.formPOEInformation.controls['mSInvoicePaidDate'].value,
      'MM/dd/yyyy'
    );

    const partnerStatementSentDate = datePipe.transform(
      this.formPOEInformation.controls['partnerStatementSentDate'].value,
      'MM/dd/yyyy'
    );

    this.uname = this.settingsServices.AliasName || '';

    this.addPoeInformation = {
      requestDetailId: this.engementId,
      scheduledActivityDate: scheduledActivityDate || undefined,
      expectedPoedate: expectedPOEDate || undefined,
      expectedPaymentMonth:
        this.formPOEInformation.controls['expectedPaymentMonth'].value
          .fiscal_Month,
      expectedPaymentMonthId:
        this.formPOEInformation.controls['expectedPaymentMonth'].value
          .fiscalMonthId,
      confidenceId:
        this.formPOEInformation.controls['confidenceHighMediumLowReceived']
          .value.confidenceID,
      confidenceHighMediumLowReceived:
        this.formPOEInformation.controls['confidenceHighMediumLowReceived']
          .value.confidence,
      workshopCompletionDate: workshopCompletionDate || undefined,
      engagementTypeId: this.formPOEInformation.controls[
        'workshopTypeCompleted'
      ].value
        ? this.formPOEInformation.controls['workshopTypeCompleted'].value
            .engagementTypeId
        : null,
      workshopTypeCompleted: this.formPOEInformation.controls[
        'workshopTypeCompleted'
      ].value
        ? this.formPOEInformation.controls['workshopTypeCompleted'].value
            .engagementType
        : null,
      customerSuccessSolutionPlanDateReceivedTwaonly:
        tWACustomerSuccessSolutionPlanDateReceived || undefined,
      twareportAndRecommendationsReportDateReceived:
        tWAReportandRecommendationsreportDateReceived || undefined,
      customerPostAssessmentSurveyDateReceived:
        customerPostassessmentSurveyDateReceived || undefined,
      engagementCompletionDateDateCustomerSignedPoe:
        engagementCompletionDate || undefined,
      securityStrategyReportSwonly:
        sWSecurityStrategyReportDateReceived || undefined,
      partnerDeliveryContactPartnerDomain:
        this.formPOEInformation.controls['partnerDeliveryContact'].value,
      partnerDeliveryContactEmailPartnerDomain:
        this.formPOEInformation.controls['partnerDeliveryContactEmail'].value,
      customerContactNameCustomerDomain:
        this.formPOEInformation.controls['customerContactName'].value,
      customerContactEmailCustomerDomain:
        this.formPOEInformation.controls['customerContactEmail'].value,
      msinvoiceNumberPmodomain:
        this.formPOEInformation.controls['mSInvoiceNumber'].value,
      paymentCentralTransactionIdpmodomain:
        this.formPOEInformation.controls['paymentCentralTransactionID'].value,
      partnerPaymentProfileStatus:
        this.formPOEInformation.controls['partnerPaymentProfileStatus'].value,
      supplierID: this.formPOEInformation.controls['supplierID'].value,
      payeeID: this.formPOEInformation.controls['payeeID'].value,
      payeeName: this.formPOEInformation.controls['payeeName'].value,
      agreement: this.formPOEInformation.controls['agreement'].value,
      submittedDate: this.formPOEInformation.controls['submittedDate'].value,
      milestoneOneCompletedDate:
        this.formPOEInformation.controls['milestoneOneCompletedDate'].value,
      msinvoiceDate: mSInvoicePaidDate || undefined,
      partnerStatementSentDate: partnerStatementSentDate || undefined,
      statementNumber:
        this.formPOEInformation.controls['statementNumber'].value,
      lastUserAlias: this.uname
    };

    this.osmEdit.addPoeInformation(this.addPoeInformation).subscribe(
      messageResponse => {
        this.apires = messageResponse;
        if (this.apires.success === true) {
          this.refreshPartnerInput.emit();
          if (this.formPOEInformation.controls['workshopTypeCompleted'].value) {
            this.formEngagementDetails.controls['engagementType'].setValue(
              this.formPOEInformation.controls['workshopTypeCompleted'].value
                .engagementType
            );
          }

          this.msgsPoe = [];
          this.msgsPoe.push({
            severity: 'success',
            detail: 'Activity Payment Information Saved Successfully.'
          });
          this.buttonClicked = false;
          this.isReadonlyPOE = true;
          this.btnNavPoe = false;
          this.formPOEInformation.disable();
        }
        if (this.apires.success === false) {
          this.msgsPoe = [];
          this.msgsPoe.push({
            severity: 'error',
            detail: this.apires.errorMessages
              ? this.apires.errorMessages[0]
              : 'Unknown error'
          });
        }
      },
      error => {
        this.msgsPoe = [];
        let errors: string[] = [];
        if (error.status === 400) {
          errors = this.commonService.getBadRequestErrors(error);
          for (const msg of errors) {
            this.msgsPoe.push({ severity: 'warn', detail: msg });
          }
        } else {
          this.msgsPoe.push({
            severity: 'warn',
            detail:
              'Sorry an Error Occurred while Adding PoeInformation Details'
          });
        }
      }
    );
  }

  onSubmitPOESurvey() {
    const datePipe = new DatePipe('en-US');

    const pOECompletionDate = datePipe.transform(
      this.formPOESurvey.controls['pOECompletionDate'].value,
      'MM/dd/yyyy'
    );

    const pOEDocumentSubmittedDate = datePipe.transform(
      this.formPOESurvey.controls['poeDocumentSubmittedDate'].value,
      'MM/dd/yyyy'
    );

    const customerPOESurveyDate = datePipe.transform(
      this.formPOESurvey.controls['customerPOESurveyDate'].value,
      'MM/dd/yyyy'
    );

    const PartnerPOESurveyDate = datePipe.transform(
      this.formPOESurvey.controls['partnerPOESurveyDate'].value,
      'MM/dd/yyyy'
    );

    this.addPoeInformationSurvey = {
      requestDetailId: this.engementId,
      poeStatusId: this.formPOESurvey.controls['PoeStatus1'].value.poeStatusId,
      poeStatusName:
        this.formPOESurvey.controls['PoeStatus1'].value.poeStatusName,
      poecompletionDate: pOECompletionDate || undefined,
      partnerPOESurveyStatusId:
        this.formPOESurvey.controls['partnerPOESurveyStatus'].value
          .poeSurveyStatusId,
      partnerPOESurveyStatus:
        this.formPOESurvey.controls['partnerPOESurveyStatus'].value
          .poeSurveyStatusName,
      customerPOESurveyStatusId:
        this.formPOESurvey.controls['customerPOESurveyStatus'].value
          .poeSurveyStatusId,
      customerPOESurveyStatus:
        this.formPOESurvey.controls['customerPOESurveyStatus'].value
          .poeSurveyStatusName,
      pOEDOCstatusId:
        this.formPOESurvey.controls['poeDOCstatusCn'].value.poeDocStatusId,
      pOEDOCstatus:
        this.formPOESurvey.controls['poeDOCstatusCn'].value.poeDocStatusName,
      poeInvoiceStatusID:
        this.formPOESurvey.controls['poeInvoicestatus'].value
          .poeInvoiceStatusID,
      poeInvoiceStatusName:
        this.formPOESurvey.controls['poeInvoicestatus'].value
          .poeInvoiceStatusName,
      pOEDocumentSubmittedDate: pOEDocumentSubmittedDate || undefined,
      customerPOESurveyDate: customerPOESurveyDate || undefined,
      partnerPOESurveyDate: PartnerPOESurveyDate || undefined,
      lastUserAlias: this.settingsServices.AliasName || ''
    };

    this.osmEdit
      .addPoeInformationSurvey(this.addPoeInformationSurvey)
      .subscribe(
        messageResponse => {
          this.apires = messageResponse;
          if (this.apires.success === true) {
            this.refreshPartnerInput.emit();
            this.formEngagementDetails.controls['engagementType'].setValue(
              this.formPOEInformation.controls['workshopTypeCompleted'].value
                .engagementType
            );

            this.msgsPoeSurvey = [];
            this.msgsPoeSurvey.push({
              severity: 'success',
              detail: 'PoeSurvey Saved Successfully.'
            });

            this.btnNavPoeSurvey = false;
            this.isReadonlyPOESurvey = true;
            this.formPOESurvey.disable();
          }
          if (this.apires.success === false) {
            this.msgsPoeSurvey = [];
            this.msgsPoeSurvey.push({
              severity: 'error',
              detail: this.apires.message
            });
          }
        },
        error => {
          this.msgsPoeSurvey = [];
          let errors: string[] = [];
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.msgsPoeSurvey.push({ severity: 'warn', detail: msg });
            }
          } else {
            this.msgsPoeSurvey.push({
              severity: 'warn',
              detail:
                'Sorry an Error Occured while Adding PoeInformation Details'
            });
          }
        }
      );
  }

  onSubmitEngagementDetails(formEngagement: FormGroup) {
    this.isBusy = true;
    if (formEngagement.status == 'VALID') {
      const extendedEngagement: EngagementExtensionDetails = {
        isEngagementExtended: this.formEngagement.controls['isExtended'].value,
        extendedExpirationDate:
          this.formEngagement.controls['extendedDate'].value,
        requestDetailId: this.engementId
      };

      if (
        extendedEngagement.isEngagementExtended &&
        extendedEngagement.extendedExpirationDate != null
      ) {
        this.osmEdit
          .addEngagementExtension(extendedEngagement)
          .pipe(take(1))
          .subscribe();
      }

      const datePipe = new DatePipe('en-US');

      const businessDays = Number(
        this.formEngagement.controls['businessDays'].value
      );

      const eligibleDate = datePipe.transform(
        this.formEngagement.controls['eligibleDate'].value,
        'MM/dd/yyyy'
      );

      const thirtyDayReminderSentDate = datePipe.transform(
        this.formEngagement.controls['thirtyDayReminderSentDate'].value,
        'MM/dd/yyyy'
      );

      const e30dayExpirationDate1 = datePipe.transform(
        this.formEngagement.controls['e30dayExpirationDate'].value,
        'MM/dd/yyyy'
      );

      const committedDate = datePipe.transform(
        this.formEngagement.controls['committedDate'].value,
        'MM/dd/yyyy'
      );

      const declineEmailSent = datePipe.transform(
        this.formEngagement.controls['declineEmailSent'].value,
        'MM/dd/yyyy'
      );

      const committedEmailSent = datePipe.transform(
        this.formEngagement.controls['committedEmailSent'].value,
        'MM/dd/yyyy'
      );

      const reminderSentDate = datePipe.transform(
        this.formEngagement.controls['reminderSentDate'].value,
        'MM/dd/yyyy'
      );

      this.addEngagementDetails = {
        requestDetailId: this.engementId,
        qualifiedAmount: this.formEngagement.controls['qualifiedAmount'].value,
        taskOwnerId:
          this.formEngagement.controls['taskOwner'].value.taskOwnerId != null
            ? this.formEngagement.controls['taskOwner'].value.taskOwnerId
            : null,
        taskOwnerName:
          this.formEngagement.controls['taskOwner'].value.taskOwner,
        pmonextStepId:
          this.formEngagement.controls['pMONextSteps'].value.pmonextStepId !=
          null
            ? this.formEngagement.controls['pMONextSteps'].value.pmonextStepId
            : null,
        pmonextStepName:
          this.formEngagement.controls['pMONextSteps'].value.pmoNextStepName,
        isIncentiveApplied: this.appliedValue === 'true' ? true : false,
        incentiveAmount:
          this.appliedValue === 'true'
            ? this.formEngagement.controls['incentiveAmount'].value
            : 0,
        incentiveQualified:
          this.appliedValue === 'true'
            ? this.formEngagement.controls['oDimIncentive'].value
                .incentiveQualified
            : undefined,
        incentiveQualifiedID:
          this.appliedValue === 'true'
            ? this.formEngagement.controls['oDimIncentive'].value
                .incentiveQualifiedID
            : undefined,
        l1internalStatusId:
          this.formEngagement.controls['t1InternalStatus'].value
            .l1internalStatusId != null
            ? this.formEngagement.controls['t1InternalStatus'].value
                .l1internalStatusId
            : null,
        l1internalStatusName:
          this.formEngagement.controls['t1InternalStatus'].value
            .l1internalStatus,
        opsStatusId:
          this.formEngagement.controls['opsStatus'].value.l2internalStatusId !=
          null
            ? this.formEngagement.controls['opsStatus'].value.l2internalStatusId
            : null,
        l2internalStatusName:
          this.formEngagement.controls['opsStatus'].value.l2internalStatus,
        declineReasonsId:
          this.formEngagement.controls['declineReasons'].value
            .declineReasonId != null
            ? this.formEngagement.controls['declineReasons'].value
                .declineReasonId
            : null,
        declineReasonName:
          this.formEngagement.controls['declineReasons'].value.declineReason,
        businessDaysfromSubmissiontoUpdatedStatus: businessDays,
        eligibleDate: eligibleDate || undefined,
        daysSinceCustomerConfirmationAgreementEmailSentCancelAfter30Days:
          this.formEngagement.controls['daysSinceCustomer'].value,
        thirtyDayReminderSentDate: thirtyDayReminderSentDate || undefined,
        day30ExpirationDate: e30dayExpirationDate1 || undefined,
        committedDate: committedDate || undefined,
        declineEmailSent: declineEmailSent || undefined,
        committedEmailSent: committedEmailSent || undefined,
        daysSinceCommittedEmailSentCancelAfter90days:
          this.formEngagement.controls['daysSinceCommittedEmailSent'].value,
        reminderSentDate: reminderSentDate || undefined,
        msxid: this.formEngagement.controls['msxid'].value,
        lastUserAlias: this.settingsServices.AliasName || '',
        engagementType: this.formEngagement.controls['engagementType']?.value
      };

      this.addEngagementDetailsDto = {
        milestonePaymentStatusId:
          this.formEngagement.controls['milestonePaymentStatus'].value
            .milestonePaymentStatusId != null
            ? this.formEngagement.controls['milestonePaymentStatus'].value
                .milestonePaymentStatusId
            : null,
        milestonePaymentStatusName:
          this.formEngagement.controls['milestonePaymentStatus'].value
            .milestonePaymentStatusName,
        engagementDetails: this.addEngagementDetails
      };

      this.osmEdit.addEngagementDetails(this.addEngagementDetailsDto).subscribe(
        messageResponse => {
          this.apires = messageResponse;
          if (this.apires.success === true) {
            this.refreshPartnerInput.emit();
            this.msgsEngDetails = [];
            this.formEngagement.controls['committedDate'].setValue(
              committedDate
            );
            this.msgsEngDetails.push({
              severity: 'success',
              detail: 'Engagement Details Saved Successfully.'
            });

            this.isReadonlyEng = true;
            this.btnNavEngDetails = false;
            this.formEngagementDetails.disable();

            this.formEngagementDetails.controls['enagementTaskOwner'].setValue(
              this.formEngagement.controls['taskOwner'].value.taskOwner
            );
            this.formEngagementDetails.controls['enagementNextSteps'].setValue(
              this.formEngagement.controls['pMONextSteps'].value.pmoNextStepName
            );

            this.completed = [
              'Complete',
              'Ready for payment',
              'Ready for payment - POE Approved',
              'Submitted for Payment',
              'Paid',
              'Submit in PC',
              'Qualified for Milestone 2'
            ];

            this.approved = [
              'Committed',
              'POE in review',
              'Partial POE',
              'POE Requires Improvements'
            ];
            this.eligible = ['Qualified'];
            this.inEligible = ['Cancelled', 'Declined', 'On-hold', 'Expired'];
            this.new = ['New'];

            if (
              this.completed.indexOf(
                this.formEngagement.controls['t1InternalStatus'].value
                  .l1internalStatus
              ) !== -1
            ) {
              this.formEngagementDetails.controls['enagementStatus'].setValue(
                'Completed'
              );
            } else if (
              this.approved.indexOf(
                this.formEngagement.controls['t1InternalStatus'].value
                  .l1internalStatus
              ) !== -1
            ) {
              this.formEngagementDetails.controls['enagementStatus'].setValue(
                'Approved'
              );
            } else if (
              this.eligible.indexOf(
                this.formEngagement.controls['t1InternalStatus'].value
                  .l1internalStatus
              ) !== -1
            ) {
              this.formEngagementDetails.controls['enagementStatus'].setValue(
                'Eligible'
              );
            } else if (
              this.inEligible.indexOf(
                this.formEngagement.controls['t1InternalStatus'].value
                  .l1internalStatus
              ) !== -1
            ) {
              this.formEngagementDetails.controls['enagementStatus'].setValue(
                'Ineligible'
              );
            } else if (
              this.new.indexOf(
                this.formEngagement.controls['t1InternalStatus'].value
                  .l1internalStatus
              ) !== -1
            ) {
              this.formEngagementDetails.controls['enagementStatus'].setValue(
                'New'
              );
            } else {
              this.formEngagementDetails.controls['enagementStatus'].setValue(
                null
              );
            }
          }
          if (this.apires.success === false) {
            this.msgsEngDetails = [];
            this.msgsEngDetails.push({
              severity: 'error',
              detail: this.apires.message
            });
          }
          this.isBusy = false;
        },
        error => {
          this.msgsEngDetails = [];
          let errors: string[] = [];
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.msgsEngDetails.push({ severity: 'warn', detail: msg });
            }
          } else {
            this.msgsEngDetails.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while Adding Engagement Details'
            });
          }
          this.isBusy = false;
        }
      );
    }
  }

  onSubmitUsageDetails() {
    const datePipe = new DatePipe('en-US');
    const usageSnapshotDate = datePipe.transform(
      this.formUsageDetails.controls['usageSnapshotDate'].value,
      'MM/dd/yyyy'
    );

    this.addUsage = {
      requestDetailId: this.engementId,
      usageSnapshotDate: usageSnapshotDate || undefined,
      adjustedPcinstalledBaseViaDuit:
        this.formUsageDetails.controls['adjustedPCInstalledBase'].value,
      windows10Madwindows10OfferOnly:
        this.formUsageDetails.controls['windows10MAD'].value,
      windows10Madwindows10OfferOnlyMustBeLessThan40Deployed:
        this.formUsageDetails.controls['windows10MADPer'].value,
      proPlusPaidEntitlements:
        this.formUsageDetails.controls['proPlusPaidEntitlements'].value,
      proPlusActiveUsers:
        this.formUsageDetails.controls['proPlusActiveUsers'].value,
      proPlusActiveUsersMustBe40:
        this.formUsageDetails.controls['proPlusActiveUsers40Per'].value,
      exoentitlements:
        this.formUsageDetails.controls['eXOPaidEntitlements'].value,
      exoactiveUsers: this.formUsageDetails.controls['eXOActiveUsers'].value,
      exoactiveUsersMustBe25:
        this.formUsageDetails.controls['eXOActiveUsers25Per'].value,
      sfBentitlements:
        this.formUsageDetails.controls['sfBPaidEntitlements'].value,
      sfBactiveUsers: this.formUsageDetails.controls['sfBActiveUsers'].value,
      sfBactiveUsersMustBe25:
        this.formUsageDetails.controls['sfBActiveUsers25Per'].value,
      teamsEntitlements:
        this.formUsageDetails.controls['teamsPaidEntitlements'].value,
      teamsActiveUsers:
        this.formUsageDetails.controls['teamsactiveusers'].value,
      unusedTeamsEntitlementsMustBe1000:
        this.formUsageDetails.controls['unusedTeamsEntitlements'].value,
      teamsActiveUsersPer:
        this.formUsageDetails.controls['teamsactiveusersPer'].value,
      roicomputation: this.formUsageDetails.controls['rOIComputation'].value,
      spoEntitlements: this.formUsageDetails.controls['spoEntitlements'].value,
      spoActiveUsers: this.formUsageDetails.controls['spoActiveUsers'].value,
      spoActiveUsersMustBe25:
        this.formUsageDetails.controls['spoactiveusersper'].value,
      aadpQualifiedEntitlements:
        this.formUsageDetails.controls['aadpQualifiedEntitlements'].value,
      aadpActiveEntitlements:
        this.formUsageDetails.controls['aadpActiveEntitlements'].value,
      aadpaeqePercent: this.formUsageDetails.controls['aadpaeqePercent'].value,
      teamsMeetingsQualifiedEntitlements:
        this.formUsageDetails.controls['teamsMeetingsQualifiedEntitlements']
          .value,
      teamsMeetingsActiveEntitlements:
        this.formUsageDetails.controls['teamsMeetingsActiveEntitlements'].value,
      teamsMeetingsMAUQEPercent:
        this.formUsageDetails.controls['teamsMeetingsMAUQEPercent'].value,
      lastUserAlias: this.uname
    };

    this.uname = this.settingsServices.AliasName || '';

    this.osmEdit.addUsageDetails(this.addUsage).subscribe(
      messageResponse => {
        this.apires = messageResponse;
        if (this.apires.success === true) {
          this.refreshPartnerInput.emit('');
          this.msgsUsageDetails = [];
          this.msgsUsageDetails.push({
            severity: 'success',
            detail: 'Usage Details Saved Successfully.'
          });
          this.formUsageDetails.disable();
          this.isReadonlyUsage = true;
        }
        if (this.apires.success === false) {
          this.msgsUsageDetails = [];
          this.msgsUsageDetails.push({
            severity: 'error',
            detail: this.apires.errorMessages
              ? this.apires.errorMessages[0]
              : 'Unknown error'
          });
        }
      },
      error => {
        this.msgsUsageDetails = [];
        let errors: string[] = [];
        if (error.status === 400) {
          errors = this.commonService.getBadRequestErrors(error);
          for (const msg of errors) {
            this.msgsUsageDetails.push({ severity: 'warn', detail: msg });
          }
        } else {
          this.msgsUsageDetails.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured while Adding Usage Details'
          });
        }
      }
    );
  }

  windows10MAD() {
    const windows10MADPer = Math.round(
      (this.formUsageDetails.controls['windows10MAD'].value /
        this.formUsageDetails.controls['adjustedPCInstalledBase'].value) *
        100
    );
    if (
      windows10MADPer !== Infinity &&
      !Number.isNaN(windows10MADPer) &&
      windows10MADPer.toString() !== 'NaN'
    ) {
      this.formUsageDetails.controls['windows10MADPer'].setValue(
        windows10MADPer
      );
    } else {
      this.formUsageDetails.controls['windows10MADPer'].setValue(0);
    }
  }

  proPlusactiveusers() {
    const proPlusactiveusers = Math.round(
      (this.formUsageDetails.controls['proPlusActiveUsers'].value /
        this.formUsageDetails.controls['proPlusPaidEntitlements'].value) *
        100
    );

    if (
      proPlusactiveusers !== Infinity &&
      !Number.isNaN(proPlusactiveusers) &&
      proPlusactiveusers.toString() !== 'NaN'
    ) {
      this.formUsageDetails.controls['proPlusActiveUsers40Per'].setValue(
        proPlusactiveusers
      );
    } else {
      this.formUsageDetails.controls['proPlusActiveUsers40Per'].setValue(0);
    }
  }

  eXOactiveusers() {
    const eXOactiveusers = Math.round(
      (this.formUsageDetails.controls['eXOActiveUsers'].value /
        this.formUsageDetails.controls['eXOPaidEntitlements'].value) *
        100
    );

    if (
      eXOactiveusers !== Infinity &&
      !Number.isNaN(eXOactiveusers) &&
      eXOactiveusers.toString() !== 'NaN'
    ) {
      this.formUsageDetails.controls['eXOActiveUsers25Per'].setValue(
        Math.round(eXOactiveusers)
      );
    } else {
      this.formUsageDetails.controls['eXOActiveUsers25Per'].setValue(0);
    }
  }

  SfBactiveusers() {
    const SfBactiveusers = Math.round(
      (this.formUsageDetails.controls['sfBActiveUsers'].value /
        this.formUsageDetails.controls['sfBPaidEntitlements'].value) *
        100
    );
    if (
      SfBactiveusers !== Infinity &&
      !Number.isNaN(SfBactiveusers) &&
      SfBactiveusers.toString() !== 'NaN'
    ) {
      this.formUsageDetails.controls['sfBActiveUsers25Per'].setValue(
        Math.round(SfBactiveusers)
      );
    } else {
      this.formUsageDetails.controls['sfBActiveUsers25Per'].setValue(0);
    }
  }

  teamsactiveusers() {
    const teamsactiveusers = Math.round(
      (this.formUsageDetails.controls['teamsactiveusers'].value /
        this.formUsageDetails.controls['teamsPaidEntitlements'].value) *
        100
    );

    if (
      teamsactiveusers !== Infinity &&
      !Number.isNaN(teamsactiveusers) &&
      teamsactiveusers.toString() !== 'NaN'
    ) {
      this.formUsageDetails.controls['teamsactiveusersPer'].setValue(
        teamsactiveusers
      );
    } else {
      this.formUsageDetails.controls['teamsactiveusersPer'].setValue(0);
    }

    const UnusedTeamsEntitlements = Math.round(
      this.formUsageDetails.controls['teamsPaidEntitlements'].value -
        this.formUsageDetails.controls['teamsactiveusers'].value
    );

    if (
      UnusedTeamsEntitlements !== Infinity &&
      !Number.isNaN(UnusedTeamsEntitlements) &&
      UnusedTeamsEntitlements.toString() !== 'NaN'
    ) {
      this.formUsageDetails.controls['unusedTeamsEntitlements'].setValue(
        UnusedTeamsEntitlements
      );
    } else {
      this.formUsageDetails.controls['unusedTeamsEntitlements'].setValue(0);
    }
  }

  spoactiveusers() {
    const spoactiveusersper = Math.round(
      (this.formUsageDetails.controls['spoActiveUsers'].value /
        this.formUsageDetails.controls['spoEntitlements'].value) *
        100
    );

    if (
      spoactiveusersper !== Infinity &&
      !Number.isNaN(spoactiveusersper) &&
      spoactiveusersper.toString() !== 'NaN'
    ) {
      this.formUsageDetails.controls['spoactiveusersper'].setValue(
        spoactiveusersper
      );
    } else {
      this.formUsageDetails.controls['spoactiveusersper'].setValue(0);
    }
  }

  aadp() {
    const aadpaeqePercent = Math.round(
      (this.formUsageDetails.controls['aadpActiveEntitlements'].value /
        this.formUsageDetails.controls['aadpQualifiedEntitlements'].value) *
        100
    );

    if (
      aadpaeqePercent !== Infinity &&
      !Number.isNaN(aadpaeqePercent) &&
      aadpaeqePercent.toString() !== 'NaN'
    ) {
      this.formUsageDetails.controls['aadpaeqePercent'].setValue(
        aadpaeqePercent
      );
    } else {
      this.formUsageDetails.controls['aadpaeqePercent'].setValue(0);
    }
  }

  teamsMeetings() {
    const teamsMeetingsMAUQEPercent = Math.round(
      (this.formUsageDetails.controls['teamsMeetingsActiveEntitlements'].value /
        this.formUsageDetails.controls['teamsMeetingsQualifiedEntitlements']
          .value) *
        100
    );

    if (
      teamsMeetingsMAUQEPercent !== Infinity &&
      !Number.isNaN(teamsMeetingsMAUQEPercent) &&
      teamsMeetingsMAUQEPercent.toString() !== 'NaN'
    ) {
      this.formUsageDetails.controls['teamsMeetingsMAUQEPercent'].setValue(
        teamsMeetingsMAUQEPercent
      );
    } else {
      this.formUsageDetails.controls['teamsMeetingsMAUQEPercent'].setValue(0);
    }
  }

  getDetails(id: number) {
    this.chngmsg = [];
    this.partnermsgs = [];
    this.custmsgs = [];
    this.intpmomsgs = [];
    this.msgsEngDetails = [];
    this.msgsPoe = [];
    this.msgsPoeSurvey = [];
    this.colorLoader = true;
    this.osmEdit.getEngagementExtension(id).subscribe(result => {
      this.extendedDetail = result;
    });
    this.osmEdit.getFactDataByRequestDetailsById(id).subscribe(result => {
      if (
        result.engagementTypeId == EnagagementTypes.GSI &&
        result.programTypeId == ProgramTypes.MSSP
      ) {
        this.isGsiWorkshop = true;
      }
      this.getPMONextStepsDropDown();
      this.getL2InternalStatusList();
      this.colorLoader = false;
      const datePipe = new DatePipe('en-US');
      this.engagementRequestedDate = result.requestDate
        ? new Date(result.requestDate)
        : new Date();
      const commonInputModel: CommonInputModel = {
        mpnid: result.partnerMpnid ? result.partnerMpnid.toString() : '',
        programTypeId: result.programTypeId,
        year: result.fiscalYear
      };

      this.programTypeId = result.programTypeId || -1;
      this.partnerMpnid = result.partnerMpnid || -1;
      this.reducedForMcap = result.reducedForMcap || false;
      this.getPartnerPaymentDetails(commonInputModel);
      this.formEngagementDetails.patchValue({
        engagementKey: id,
        engagementName: result.engagementName,
        requestDate: result.requestDate,
        pMOPartnerName: result.pmoconfirmedPartnerName,
        enagementTaskOwner: result.taskOwnerName,
        enagementPMOTenantName: result.pmoConfirmedTenantName,
        enagementNextSteps: result.pmonextStepName,
        engagementType: result.deliveryName,
        engagementRequestID: result.partnerConfirmNum,
        enagementStatus: result.engagementStatus
      });

      this.formPartner.patchValue({
        mPNID: result.partnerInputMpnid,
        partnerName: result.partnerInputPartnerName,
        partnerInputRequestorContact: result.partnerInputRequestorContact,
        partnerInputRequestorEmail: result.partnerInputRequestorEmail,
        sSPAStatusCompliant: result.sspastatusCompliant,
        countryName: result.countryName,
        InternalRefPartnerName: result.partnerName,
        partnerOneID: result.partnerOneId,
        partnerLocation: result.partnerLocation,
        partnerEarnedLocation: result.partnerEarnedLocation,
        partnerAreaLocationA14: result.partnerAreaLocationA14,
        additionalContactEmails: result.additionalContactEmails,
        pmomPNID: result.pmoconfirmedPartnerMpnid,
        pmopartnerName: result.pmoconfirmedPartnerName
      });

      this.partnerLocation = result.partnerLocation || '';

      this.formPartner.controls['partnerType'].setValue({
        partnerTypeId: result.partnerTypeId,
        partnerType: result.partnerTypeIdName
      });

      this.formCustomer.patchValue({
        tPID: result.partnerInputCustomerTpid,
        tPName: result.partnerInputCustomerName,
        customerTPIDListbasedonTenantID: result.customerTpidlist,
        segmentGroup: result.segmentGroup,
        customerArea: result.customerLocation,
        customerCountry: result.partnerInputCustomerCountry,
        usageArea: result.usageAreaPartnerEnteredisEmpty,
        usageCountry: result.usageCountryPartnerEnteredisEmpty,
        tenantID: result.partnerInputTenantId,
        tanantName: result.partnerInputTenantName,
        domainName: result.partnerInputDomainName,
        tenantListbasedonTPID: result.tenantListbasedonTpid,
        pmotPID: result.pmoConfirmedCustomerTPID,
        pmocustomerArea: result.pmoConfirmedTopParentCustomerArea,
        pmocustomerCountry: result.pmoConfirmedTopParentCustomerCountry,
        pmousageArea: result.pmoConfirmedUsageArea,
        pmousageCountry: result.pmoConfirmedUsageCountry,
        pmotenantID: result.pmoConfirmedTenantId,
        pmodomainName: result.pmoConfirmedDomainName,
        pmotanantName: result.pmoConfirmedTenantName,
        pmotPName: result.pmoConfimedTopParentCustomerName
      });
      this.customerCountry = result.pmoConfirmedTopParentCustomerCountry || '';

      if (
        result.fullyExecutedAndPaidFromTheFy19twaprogramYnfy19paidTwa === true
      ) {
        this.formInternalPMO.controls[
          'fullyexecutedandpaidfromtheFY19TWAProgramYN'
        ].setValue('true');
      } else {
        this.formInternalPMO.controls[
          'fullyexecutedandpaidfromtheFY19TWAProgramYN'
        ].setValue('false');
      }

      if (
        result.fullyExecutedAndPaidFromTheFy19mdaprogramYnfy19paidMda === true
      ) {
        this.formInternalPMO.controls[
          'fullyexecutedandpaidfromtheFY19MDAProgramYN'
        ].setValue('true');
      } else {
        this.formInternalPMO.controls[
          'fullyexecutedandpaidfromtheFY19MDAProgramYN'
        ].setValue('false');
      }

      if (
        result.partnerRequestedSameTenantIdynduplicateTenantFromSamePartner ===
        true
      ) {
        this.formInternalPMO.controls[
          'partnerRequestedsameTenantIDYN'
        ].setValue('true');
      } else {
        this.formInternalPMO.controls[
          'partnerRequestedsameTenantIDYN'
        ].setValue('false');
      }

      if (
        result.anotherPartnerRequestedSameTenantIdynduplicateTenantFromAnotherPartner ===
        true
      ) {
        this.formInternalPMO.controls[
          'anotherPartnerRequestedSameTenantID'
        ].setValue('true');
      } else {
        this.formInternalPMO.controls[
          'anotherPartnerRequestedSameTenantID'
        ].setValue('false');
      }

      if (result.c3customerYn === true) {
        this.formInternalPMO.controls['C3SWPartner'].setValue('true');
      } else {
        this.formInternalPMO.controls['C3SWPartner'].setValue('false');
      }
      if (result.c3TWAPartnerYN === true) {
        this.formInternalPMO.controls['C3TWAPartner'].setValue('true');
      } else {
        this.formInternalPMO.controls['C3TWAPartner'].setValue('false');
      }

      this.formInternalPMO.patchValue({
        fullyexecutedandpaidfromtheFY19TWAProgramYNrequestIds:
          result.fullyExecutedAndPaidFromTheFY19TWAProgramYNFY19PaidTWARequestIds,
        fullyexecutedandpaidfromtheFY19MDAProgramYNrequestIds:
          result.fullyExecutedAndPaidFromTheFY19MDAProgramYNFY19PaidMDARequestIds,
        partnerRequestedsameTenantIDYNrequestIds:
          result.partnerRequestedSameTenantIDYNDuplicateTenantFromSamePartnerRequestIds,
        anotherPartnerRequestedSameTenantIDMpnids:
          result.anotherPartnerRequestedSameTenantIDYNDuplicateTenantFromAnotherPartnerMPNIDS
      });
      const usageSnapshotDate2 = datePipe.transform(
        result.usageSnapshotDate,
        'MM/dd/yyyy'
      );

      this.formUsageDetails.patchValue({
        usageSnapshotDate: usageSnapshotDate2,
        adjustedPCInstalledBase: result.adjustedPcinstalledBaseViaDuit,
        windows10MAD: result.windows10Madwindows10OfferOnly,
        windows10MADPer:
          result.windows10Madwindows10OfferOnlyMustBeLessThan40Deployed,
        proPlusPaidEntitlements: result.proPlusPaidEntitlements,
        proPlusActiveUsers: result.proPlusActiveUsers,
        proPlusActiveUsers40Per: result.proPlusActiveUsersMustBe40,
        eXOPaidEntitlements: result.exoentitlements,
        eXOActiveUsers: result.exoactiveUsers,
        eXOActiveUsers25Per: result.exoactiveUsersMustBe25,
        sfBPaidEntitlements: result.sfBentitlements,
        sfBActiveUsers: result.sfBactiveUsers,
        sfBActiveUsers25Per: result.sfBactiveUsersMustBe25,
        teamsPaidEntitlements: result.teamsEntitlements,
        teamsactiveusers: result.teamsActiveUsers,
        unusedTeamsEntitlements: result.unusedTeamsEntitlementsMustBe1000,
        teamsactiveusersPer: result.teamsActiveUsersPer,
        rOIComputation: result.roicomputation,
        spoEntitlements: result.spoEntitlements,
        spoActiveUsers: result.spoActiveUsers,
        spoactiveusersper: result.spoActiveUsersMustBe25,
        aadpQualifiedEntitlements: result.aadpQualifiedEntitlements,
        aadpActiveEntitlements: result.aadpActiveEntitlements,
        aadpaeqePercent: result.aadpaeqePercent,
        teamsMeetingsQualifiedEntitlements:
          result.teamsMeetingsQualifiedEntitlements,
        teamsMeetingsActiveEntitlements: result.teamsMeetingsActiveEntitlements,
        teamsMeetingsMAUQEPercent: result.teamsMeetingsMAUQEPercent
      });

      const scheduledActivityDate = datePipe.transform(
        result.scheduledActivityDate,
        'MM/dd/yyyy'
      );
      const expectedPoedate = datePipe.transform(
        result.expectedPoedate,
        'MM/dd/yyyy'
      );
      const workshopCompletionDate = datePipe.transform(
        result.workshopCompletionDate,
        'MM/dd/yyyy'
      );
      const customerSuccessSolutionPlanDateReceivedTwaonly = datePipe.transform(
        result.customerSuccessSolutionPlanDateReceivedTwaonly,
        'MM/dd/yyyy'
      );
      const twareportAndRecommendationsReportDateReceived = datePipe.transform(
        result.twareportAndRecommendationsReportDateReceived,
        'MM/dd/yyyy'
      );
      const customerPostAssessmentSurveyDateReceived = datePipe.transform(
        result.customerPostAssessmentSurveyDateReceived,
        'MM/dd/yyyy'
      );
      const poecompletionDate = datePipe.transform(
        result.poeCompletionDate,
        'MM/dd/yyyy'
      );
      const engagementCompletionDateDateCustomerSignedPoe = datePipe.transform(
        result.engagementCompletionDateDateCustomerSignedPoe,
        'MM/dd/yyyy'
      );
      const securityStrategyReportSwonly = datePipe.transform(
        result.securityStrategyReportSwonly,
        'MM/dd/yyyy'
      );
      const msinvoiceDate = datePipe.transform(
        result.msInvoiceDate,
        'MM/dd/yyyy'
      );

      const pOEDocumentSubmittedDate = datePipe.transform(
        result.poeDocumentSubmittedDate,
        'MM/dd/yyyy'
      );
      this.CustomerPOESurveyDate = datePipe.transform(
        result.customerPOESurveyDate,
        'MM/dd/yyyy'
      );
      const PartnerStatementSentDate = datePipe.transform(
        result.partnerStatementSentDate,
        'MM/dd/yyyy'
      );
      this.PartnerPOESurveyDate = datePipe.transform(
        result.partnerPOESurveyDate,
        'MM/dd/yyyy'
      );

      const SubmittedDate = datePipe.transform(
        result.submittedDate,
        'MM/dd/yyyy'
      );
      const milestoneOneCompletedDate = datePipe.transform(
        result.milestoneOneCompletedDate,
        'MM/dd/yyyy'
      );

      this.getPoeStatus();

      this.statementNumberTemp = result.statementNumber;

      if (result.partnerPaymentProfileStatus === true) {
        this.formPOEInformation.controls[
          'partnerPaymentProfileStatus'
        ].setValue('true');
      } else {
        this.formPOEInformation.controls[
          'partnerPaymentProfileStatus'
        ].setValue('false');
      }
      if (result.agreement === true) {
        this.formPOEInformation.controls['agreement'].setValue('true');
      } else {
        this.formPOEInformation.controls['agreement'].setValue('false');
      }
      this.formPOEInformation.patchValue({
        scheduledActivityDate: scheduledActivityDate,
        expectedPOEDate: expectedPoedate,
        workshopCompletionDate: workshopCompletionDate,
        workshopTypeCompleted: result.workshopTypeCompleted,
        tWACustomerSuccessSolutionPlanDateReceived:
          customerSuccessSolutionPlanDateReceivedTwaonly,
        tWAReportandRecommendationsreportDateReceived:
          twareportAndRecommendationsReportDateReceived,
        customerPostassessmentSurveyDateReceived:
          customerPostAssessmentSurveyDateReceived,
        engagementCompletionDate: engagementCompletionDateDateCustomerSignedPoe,
        sWSecurityStrategyReportDateReceived: securityStrategyReportSwonly,
        partnerDeliveryContact: result.partnerDeliveryContactPartnerDomain,
        partnerDeliveryContactEmail:
          result.partnerDeliveryContactEmailPartnerDomain,
        customerContactName: result.customerContactNameCustomerDomain,
        customerContactEmail: result.customerContactEmailCustomerDomain,
        mSInvoiceNumber: result.msinvoiceNumberPmodomain,
        mSInvoicePaidDate: msinvoiceDate,
        paymentCentralTransactionID:
          result.paymentCentralTransactionIdpmodomain,
        supplierID: result.supplierID,
        payeeID: result.payeeID,
        payeeName: result.payeeName,
        submittedDate: SubmittedDate,
        statementNumber: result.statementNumber,
        partnerStatementSentDate: PartnerStatementSentDate,
        milestoneOneCompletedDate: milestoneOneCompletedDate
      });

      this.formPOEInformation.controls['expectedPaymentMonth'].setValue({
        fiscalMonthId: result.expectedPaymentMonthId,
        fiscal_Month: result.expectedPaymentMonth
      });
      this.formPOEInformation.controls[
        'confidenceHighMediumLowReceived'
      ].setValue({
        confidenceID: result.confidenceId,
        confidence: result.confidenceHighMediumLowReceived
      });

      this.getEngagementType(
        result.engagementName,
        result.workshopTypeCompleted
      );

      this.formPOESurvey.patchValue({
        pOECompletionDate: poecompletionDate,
        poeDocumentSubmittedDate: pOEDocumentSubmittedDate,
        customerPOESurveyDate: this.CustomerPOESurveyDate,
        partnerPOESurveyDate: this.PartnerPOESurveyDate,
        customerSurveyName: result.customerSurveyName,
        customertype: result.customertype,
        customerSurveyCreatedDate: result.customerSurveyCreatedDate,
        partnerSurveyName: result.partnerSurveyName,
        partnerType: result.partnerType,
        partnerSurveyCreatedDate: result.partnerSurveyCreatedDate
      });

      this.formPOESurvey.controls['customerPOESurveyStatus'].setValue({
        poeSurveyStatusId: result.customerPOESurveyStatusId,
        poeSurveyStatusName: result.customerPOESurveyStatus
      });

      this.formPOESurvey.controls['partnerPOESurveyStatus'].setValue({
        poeSurveyStatusId: result.partnerPOESurveyStatusId,
        poeSurveyStatusName: result.partnerPOESurveyStatus
      });

      this.formPOESurvey.controls['PoeStatus1'].setValue({
        poeStatusId: result.poeStatusId,
        poeStatusName: result.poeStatusName
      });

      this.formPOESurvey.controls['poeDOCstatusCn'].setValue({
        poeDocStatusId: result.poedoCstatusId,
        poeDocStatusName: result.poedoCstatus
      });

      this.formPOESurvey.controls['poeInvoicestatus'].setValue({
        poeInvoiceStatusID: result.poeInvoiceStatusID,
        poeInvoiceStatusName: result.poeInvoiceStatusName
      });

      const businessDaysfromSubmissiontoUpdatedStatus =
        result.businessDaysfromSubmissiontoUpdatedStatus;

      const eligibleDate1 = datePipe.transform(
        result.eligibleDate,
        'MM/dd/yyyy'
      );

      const day30ExpirationDate = datePipe.transform(
        result.day30ExpirationDate,
        'MM/dd/yyyy'
      );

      const committedDate1 = datePipe.transform(
        result.committedDate,
        'MM/dd/yyyy'
      );

      this.initialCommittedDate = committedDate1 || '';

      const declineEmailSent1 = datePipe.transform(
        result.declineEmailSent,
        'MM/dd/yyyy'
      );

      const committedEmailSent1 = datePipe.transform(
        result.committedEmailSent,
        'MM/dd/yyyy'
      );

      const reminderSentDate1 = datePipe.transform(
        result.reminderSentDate,
        'MM/dd/yyyy'
      );

      const thirtyDayReminderSentDate1 = datePipe.transform(
        result.thirtyDayReminderSentDate,
        'MM/dd/yyyy'
      );

      const day90ExpirationDate = datePipe.transform(
        result.day90ExpirationDate,
        'MM/dd/yyyy'
      );

      this.caDeclinereason = this.getReasons(
        result.documentRejectionReasons || []
      );
      this.formEngagement.patchValue({
        qualifiedAmount: result.qualifiedAmount,
        incentiveAmount: result.incentiveAmount,
        thirtyDayReminderSentDate: thirtyDayReminderSentDate1,
        businessDays: businessDaysfromSubmissiontoUpdatedStatus,
        eligibleDate: eligibleDate1,
        daysSinceCustomer:
          result.daysSinceCustomerConfirmationAgreementEmailSentCancelAfter30Days,
        e30dayExpirationDate: day30ExpirationDate,
        committedDate: committedDate1,
        declineEmailSent: declineEmailSent1,
        committedEmailSent: committedEmailSent1,
        daysSinceCommittedEmailSent:
          result.daysSinceCommittedEmailSentCancelAfter90days,
        reminderSentDate: reminderSentDate1,
        day90ExpirationDate: day90ExpirationDate,
        daysLeftFromDay90ExpirationDate: result.daysLeftFromDay90ExpirationDate,
        activityEligibilityEndDate: datePipe.transform(
          result.activityEligibilityEndDate,
          'MM/dd/yyyy'
        ),
        fundingType: result.fundingType,
        customerAckStatus: result.customerAckDocumentStatus,
        cancelledDate: datePipe.transform(result.cancelledDate, 'MM/dd/yyyy'),
        isExtended:
          this.extendedDetail != null
            ? this.extendedDetail.isEngagementExtended
            : false,
        extendedDate:
          this.extendedDetail != null
            ? datePipe.transform(
                this.extendedDetail.extendedExpirationDate,
                'MM/dd/yyyy'
              )
            : null,
        msxid: result.msxid,
        hasCustomerAcknowledgement: result.hasCustomerAcknowledgement
      });

      if (result.isIncentiveApplied === true) {
        this.appliedValue = 'true';
      } else {
        this.appliedValue = 'false';
      }
      if (result.isIncentiveApplied === null) {
        this.formEngagement.controls['incentiveApplied'].setValue('');
      }

      this.formEngagement.controls['taskOwner'].setValue({
        taskOwnerId: result.taskOwnerId,
        taskOwner: result.taskOwnerName
      });

      this.formEngagement.controls['t1InternalStatus'].setValue({
        l1internalStatusId: result.l1internalStatusId,
        l1internalStatus: result.l1internalStatusName
      });

      this.formEngagement.controls['opsStatus'].setValue({
        l2internalStatusId: result.opsStatusId,
        l2internalStatus: result.l2internalStatusName
      });

      this.formEngagement.controls['milestonePaymentStatus'].setValue({
        milestonePaymentStatusId: result.milestonePaymentStatusId,
        milestonePaymentStatusName: result.milestonePaymentStatusName
      });

      this.formEngagement.controls['declineReasons'].setValue({
        declineReasonId: result.declineReasonsId,
        declineReason: result.declineReasonName
      });

      this.formEngagement.controls['pMONextSteps'].setValue({
        pmonextStepId: result.pmonextStepId,
        pmoNextStepName: result.pmonextStepName
      });

      this.formEngagement.controls['oDimIncentive'].setValue({
        incentiveQualifiedID: result.incentiveQualifiedID,
        incentiveQualified: result.incentiveQualified
      });

      this.getPartnerComplianceInformation();
    });
  }

  getPartnerComplianceInformation() {
    if (this.partnerMpnid > 0) {
      this.isPartnerBlocked = false;
      this.ds
        .getPartnerComplianceInformation(this.partnerMpnid)
        .subscribe(data => {
          if (data.length > 0) {
            if (
              data.find(
                p =>
                  p.programTypeId == this.programTypeId && p.isBlocked == true
              )
            ) {
              this.isPartnerBlocked = true;
            }
          }
        });
    }
  }

  getUploadedPOEDocs_ByEngagementId(id: number) {
    this.osmEdit.getUploadedPOEDocs_ByEngagementId(id).subscribe(result => {
      this.poeDocHyperLinks = result;
    });
  }
  getUploadedAdditionalDocs_ByEngagementId(id: number) {
    this.osmEdit
      .getUploadedAdditionalDocs_ByEngagementId(id)
      .subscribe(result => {
        this.additionalDocHyperLinks = result;
      });
  }

  getPOEDocumentHistory(id: number) {
    this.osmEdit.getPOEDocumentHistory(id).subscribe(result => {
      this.poeHistoryDocuments = result;
    });
  }

  refreshAllTab() {
    this.umsgs = [];
    this.chngmsg = [];

    this.partnermsgs = [];
    this.isReadonlypart = true;
    this.partbtnNav = false;

    this.custmsgs = [];
    this.isReadonlycust = true;
    this.custbtnNav = false;

    this.intpmomsgs = [];
    this.isReadonlyIntPMO = true;
    this.intPMObtnNav = false;

    this.msgsUsageDetails = [];
    this.isReadonlyUsage = true;

    this.msgsEngDetails = [];
    this.isReadonlyEng = true;
    this.btnNavEngDetails = false;

    this.msgsPoe = [];
    this.isReadonlyPOE = true;
    this.btnNavPoe = false;

    this.msgsPoeSurvey = [];
    this.isReadonlyPOESurvey = true;
    this.btnNavPoeSurvey = false;

    this.chngmsg = [];
    this.isReadonlyChaneEng = true;
    this.btnDisable = false;
    this.engBtnNav = false;

    this.loadcustomAck = false;
    this.transactionSpin = false;
    this.selectedEngType = null;
    this.selectedEngName = null;
    this.changeEngDropdown = [];
    this.changeEngName = [];
    this.changeEngType = [];
    this.filesUpload = [];

    this.onFromGroup();
  }

  editPartner() {
    this.isReadonlypart = false;
    this.partbtnNav = true;
    this.formPartner.enable();
  }

  editEng() {
    this.selectedEngType = null;
    this.selectedEngName = null;
  }

  editUsage() {
    this.isReadonlyUsage = false;
    this.CancelUsage(this.engementId);
    this.formUsageDetails.enable();
  }

  cancelEditUsage() {
    this.msgsUsageDetails = [];

    this.isReadonlyUsage = true;
    this.formUsageDetails.disable();
  }

  editCustomerCancel() {
    this.isReadonlycust = true;
    this.custmsgs = [];
    this.custbtnNav = false;
    this.CancelCustomerdetails(this.engementId);
    this.formCustomer.disable();
  }

  editChangeEngVal() {
    this.isReadonlyChaneEng = true;
    this.chngmsg = [];
    this.engBtnNav = false;
    this.selectedEngType = null;
    this.CancelChangeEngVal(this.engementId);
    this.selectedEngName = null;
  }

  CancelPmoDetails() {
    this.isReadonlyIntPMO = true;
    this.intpmomsgs = [];
    this.intPMObtnNav = false;
    this.CancelPmodetails(this.engementId);
    this.formInternalPMO.disable();
  }

  editPoeInformationCancel() {
    this.isReadonlyPOE = true;
    this.msgsPoe = [];
    this.btnNavPoe = false;
    this.CancelPoeInformation(this.engementId);
    this.formPOEInformation.disable();
  }

  editPoeSurveyCancel() {
    this.isReadonlyPOESurvey = true;
    this.msgsPoeSurvey = [];
    this.btnNavPoeSurvey = false;
    this.cancelPoeSurvey(this.engementId);
    this.formPOESurvey.disable();
  }

  editPartnerCancel() {
    this.isReadonlypart = true;
    this.partnermsgs = [];
    this.partbtnNav = false;
    this.CancelPartnerInputDetails(this.engementId);
    this.formPartner.disable();
  }

  editEngementDetailsCancel() {
    this.isReadonlyEng = true;
    this.msgsEngDetails = [];
    this.btnNavEngDetails = false;
    this.CancelEngagementDetails(this.engementId);
    this.formEngagementDetails.disable();
  }

  CancelEngagementDetails(id: number) {
    this.msgsEngDetails = [];
    this.msgsPoe = [];
    this.osmEdit.getFactDataByRequestDetailsById(id).subscribe(result => {
      const datePipe = new DatePipe('en-US');
      const businessDaysfromSubmissiontoUpdatedStatus =
        result.businessDaysfromSubmissiontoUpdatedStatus;

      const eligibleDate = datePipe.transform(
        result.eligibleDate,
        'MM/dd/yyyy'
      );
      const day30ExpirationDate = datePipe.transform(
        result.day30ExpirationDate,
        'MM/dd/yyyy'
      );
      const committedDate = datePipe.transform(
        result.committedDate,
        'MM/dd/yyyy'
      );
      const declineEmailSent = datePipe.transform(
        result.declineEmailSent,
        'MM/dd/yyyy'
      );
      const committedEmailSent = datePipe.transform(
        result.committedEmailSent,
        'MM/dd/yyyy'
      );
      const reminderSentDate = datePipe.transform(
        result.reminderSentDate,
        'MM/dd/yyyy'
      );
      const day90ExpirationDate = datePipe.transform(
        result.day90ExpirationDate,
        'MM/dd/yyyy'
      );

      this.formEngagement.patchValue({
        qualifiedAmount: result.qualifiedAmount,
        incentiveAmount: result.incentiveAmount,
        businessDays: businessDaysfromSubmissiontoUpdatedStatus,
        eligibleDate: eligibleDate,
        daysSinceCustomer:
          result.daysSinceCustomerConfirmationAgreementEmailSentCancelAfter30Days,
        e30dayExpirationDate: day30ExpirationDate,
        committedDate: committedDate,
        declineEmailSent: declineEmailSent,
        committedEmailSent: committedEmailSent,
        daysSinceCommittedEmailSent:
          result.daysSinceCommittedEmailSentCancelAfter90days,
        reminderSentDate: reminderSentDate,
        day90ExpirationDate: day90ExpirationDate,
        daysLeftFromDay90ExpirationDate: result.daysLeftFromDay90ExpirationDate,
        activityEligibilityEndDate: datePipe.transform(
          result.activityEligibilityEndDate,
          'MM/dd/yyyy'
        ),
        fundingType: result.fundingType,
        isExtended:
          this.extendedDetail != null
            ? this.extendedDetail.isEngagementExtended
            : false,
        extendedDate:
          this.extendedDetail != null
            ? datePipe.transform(
                this.extendedDetail.extendedExpirationDate,
                'MM/dd/yyyy'
              )
            : null
      });

      if (result.isIncentiveApplied === true) {
        this.appliedValue = 'true';
      } else {
        this.appliedValue = 'false';
      }
      if (result.isIncentiveApplied === null) {
        this.formEngagement.controls['incentiveApplied'].setValue('');
      }
      this.formEngagement.controls['taskOwner'].setValue({
        taskOwnerId: result.taskOwnerId,
        taskOwner: result.taskOwnerName
      });

      this.formEngagement.controls['t1InternalStatus'].setValue({
        l1internalStatusId: result.l1internalStatusId,
        l1internalStatus: result.l1internalStatusName
      });

      this.formEngagement.controls['opsStatus'].setValue({
        l2internalStatusId: result.opsStatusId,
        l2internalStatus: result.l2internalStatusName
      });

      this.formEngagement.controls['declineReasons'].setValue({
        declineReasonId: result.declineReasonsId,
        declineReason: result.declineReasonName
      });

      this.formEngagement.controls['pMONextSteps'].setValue({
        pmoNextStepName: result.pmonextStepName,
        pmonextStepId: result.pmonextStepId
      });

      this.formEngagement.controls['oDimIncentive'].setValue({
        incentiveQualifiedID: result.incentiveQualifiedID,
        incentiveQualified: result.incentiveQualified
      });
    });
  }

  SetPreviousDropdownValue(id: number) {
    this.msgsPoe = [];
    this.osmEdit.getFactDataByRequestDetailsById(id).subscribe(result => {
      this.formEngagement.controls['t1InternalStatus'].setValue({
        l1internalStatusId: result.l1internalStatusId,
        l1internalStatus: result.l1internalStatusName
      });

      this.formEngagement.controls['opsStatus'].setValue({
        l2internalStatusId: result.opsStatusId,
        l2internalStatus: result.l2internalStatusName
      });

      this.formEngagement.controls['pMONextSteps'].setValue({
        pmoNextStepName: result.pmonextStepName,
        pmonextStepId: result.pmonextStepId
      });
    });
  }

  CancelChangeEngVal(id: number) {
    this.btnDisable = false;
    this.chngmsg = [];
    this.osmEdit.getFactDataByRequestDetailsById(id).subscribe(result => {
      this.formEngagementDetails.patchValue({
        engagementKey: id,
        engagementName: result.engagementName,
        requestDate: result.requestDate,
        pMOPartnerName: result.pmoconfirmedPartnerName,
        enagementTaskOwner: result.taskOwnerName,
        enagementPMOTenantName: result.pmoConfirmedTenantName,
        enagementNextSteps: result.pmonextStepName,
        engagementType: result.deliveryName,
        engagementRequestID: result.partnerConfirmNum,
        enagementStatus: result.engagementStatus
      });
    });
  }

  CancelPartnerInputDetails(id: number) {
    this.msgsPoe = [];
    this.osmEdit.getFactDataByRequestDetailsById(id).subscribe(result => {
      this.formPartner.patchValue({
        mPNID: result.partnerInputMpnid,
        partnerName: result.partnerInputPartnerName,
        partnerInputRequestorContact: result.partnerInputRequestorContact,
        partnerInputRequestorEmail: result.partnerInputRequestorEmail,
        sSPAStatusCompliant: result.sspastatusCompliant,
        countryName: result.countryName,
        InternalRefPartnerName: result.partnerName,
        partnerOneID: result.partnerOneId,
        partnerLocation: result.partnerLocation,
        partnerEarnedLocation: result.partnerEarnedLocation,
        partnerAreaLocationA14: result.partnerAreaLocationA14,
        additionalContactEmails: result.additionalContactEmails,
        pmomPNID: result.pmoconfirmedPartnerMpnid,
        pmopartnerName: result.pmoconfirmedPartnerName
      });

      this.formPartner.controls['partnerType'].setValue({
        partnerTypeId: result.partnerTypeId,
        partnerType: result.partnerTypeIdName
      });
    });
  }

  CancelUsage(id: number) {
    this.msgsPoe = [];
    this.osmEdit.getFactDataByRequestDetailsById(id).subscribe(result => {
      const datePipe = new DatePipe('en-US');
      const usageSnapshotDate2 = datePipe.transform(
        result.usageSnapshotDate,
        'MM/dd/yyyy'
      );

      this.formUsageDetails.patchValue({
        usageSnapshotDate: usageSnapshotDate2,
        adjustedPCInstalledBase: result.adjustedPcinstalledBaseViaDuit,
        windows10MAD: result.windows10Madwindows10OfferOnly,
        windows10MADPer:
          result.windows10Madwindows10OfferOnlyMustBeLessThan40Deployed,
        proPlusPaidEntitlements: result.proPlusPaidEntitlements,
        proPlusActiveUsers: result.proPlusActiveUsers,
        proPlusActiveUsers40Per: result.proPlusActiveUsersMustBe40,
        eXOPaidEntitlements: result.exoentitlements,
        eXOActiveUsers: result.exoactiveUsers,
        eXOActiveUsers25Per: result.exoactiveUsersMustBe25,
        sfBPaidEntitlements: result.sfBentitlements,
        sfBActiveUsers: result.sfBactiveUsers,
        sfBActiveUsers25Per: result.sfBactiveUsersMustBe25,
        teamsPaidEntitlements: result.teamsEntitlements,
        teamsactiveusers: result.teamsActiveUsers,
        unusedTeamsEntitlements: result.unusedTeamsEntitlementsMustBe1000,
        teamsactiveusersPer: result.teamsActiveUsersPer,
        rOIComputation: result.roicomputation,
        spoEntitlements: result.spoEntitlements,
        spoActiveUsers: result.spoActiveUsers,
        spoactiveusersper: result.spoActiveUsersMustBe25,
        aadpQualifiedEntitlements: result.aadpQualifiedEntitlements,
        aadpActiveEntitlements: result.aadpActiveEntitlements,
        aadpaeqePercent: result.aadpaeqePercent,
        teamsMeetingsQualifiedEntitlements:
          result.teamsMeetingsQualifiedEntitlements,
        teamsMeetingsActiveEntitlements: result.teamsMeetingsActiveEntitlements,
        teamsMeetingsMAUQEPercent: result.teamsMeetingsMAUQEPercent
      });
    });
  }

  CancelCustomerdetails(id: number) {
    this.msgsPoe = [];
    this.osmEdit.getFactDataByRequestDetailsById(id).subscribe(result => {
      this.formCustomer.patchValue({
        tPID: result.partnerInputCustomerTpid,
        tPName: result.partnerInputCustomerName,
        customerTPIDListbasedonTenantID: result.customerTpidlist,
        segmentGroup: result.segmentGroup,
        customerArea: result.customerLocation,
        customerCountry: result.partnerInputCustomerCountry,
        usageArea: result.usageAreaPartnerEnteredisEmpty,
        usageCountry: result.usageCountryPartnerEnteredisEmpty,
        tenantID: result.partnerInputTenantId,
        tanantName: result.partnerInputTenantName,
        domainName: result.partnerInputDomainName,
        tenantListbasedonTPID: result.tenantListbasedonTpid,

        pmotPID: result.pmoConfirmedCustomerTPID,
        pmocustomerArea: result.pmoConfirmedTopParentCustomerArea,
        pmocustomerCountry: result.pmoConfirmedTopParentCustomerCountry,
        pmousageArea: result.pmoConfirmedUsageArea,
        pmousageCountry: result.pmoConfirmedUsageCountry,
        pmotenantID: result.pmoConfirmedTenantId,
        pmodomainName: result.pmoConfirmedDomainName,
        pmotanantName: result.pmoConfirmedTenantName,
        enagementPMOTenantName: result.pmoConfirmedTenantName,
        pmotPName: result.pmoConfimedTopParentCustomerName
      });
    });
  }

  CancelPoeInformation(id: number) {
    this.msgsPoe = [];
    this.osmEdit.getFactDataByRequestDetailsById(id).subscribe(result => {
      const datePipe = new DatePipe('en-US');

      const scheduledActivityDate = datePipe.transform(
        result.scheduledActivityDate,
        'MM/dd/yyyy'
      );

      const expectedPoedate = datePipe.transform(
        result.expectedPoedate,
        'MM/dd/yyyy'
      );

      const workshopCompletionDate = datePipe.transform(
        result.workshopCompletionDate,
        'MM/dd/yyyy'
      );

      const customerSuccessSolutionPlanDateReceivedTwaonly = datePipe.transform(
        result.customerSuccessSolutionPlanDateReceivedTwaonly,
        'MM/dd/yyyy'
      );

      const twareportAndRecommendationsReportDateReceived = datePipe.transform(
        result.twareportAndRecommendationsReportDateReceived,
        'MM/dd/yyyy'
      );
      const customerPostAssessmentSurveyDateReceived = datePipe.transform(
        result.customerPostAssessmentSurveyDateReceived,
        'MM/dd/yyyy'
      );
      const poecompletionDate = datePipe.transform(
        result.poeCompletionDate,
        'MM/dd/yyyy'
      );

      const engagementCompletionDateDateCustomerSignedPoe = datePipe.transform(
        result.engagementCompletionDateDateCustomerSignedPoe,
        'MM/dd/yyyy'
      );
      const securityStrategyReportSwonly = datePipe.transform(
        result.securityStrategyReportSwonly,
        'MM/dd/yyyy'
      );

      const msinvoiceDate = datePipe.transform(
        result.msInvoiceDate,
        'MM/dd/yyyy'
      );

      const PartnerStatementSentDate = datePipe.transform(
        result.partnerStatementSentDate,
        'MM/dd/yyyy'
      );

      const SubmittedDate = datePipe.transform(
        result.submittedDate,
        'MM/dd/yyyy'
      );

      const milestoneOneCompletedDate = datePipe.transform(
        result.milestoneOneCompletedDate,
        'MM/dd/yyyy'
      );

      this.formPOEInformation.controls['expectedPaymentMonth'].setValue({
        fiscalMonthId: result.expectedPaymentMonthId,
        fiscal_Month: result.expectedPaymentMonth
      });

      this.formPOEInformation.controls[
        'confidenceHighMediumLowReceived'
      ].setValue({
        confidenceID: result.confidenceId,
        confidence: result.confidenceHighMediumLowReceived
      });

      this.formPOEInformation.controls['workshopTypeCompleted'].setValue({
        engagementTypeId: result.engagementTypeId,
        engagementName: result.engagementName,
        engagementType: result.workshopTypeCompleted
      });

      if (result.partnerPaymentProfileStatus === true) {
        this.formPOEInformation.controls[
          'partnerPaymentProfileStatus'
        ].setValue('true');
      } else {
        this.formPOEInformation.controls[
          'partnerPaymentProfileStatus'
        ].setValue('false');
      }

      if (result.agreement === true) {
        this.formPOEInformation.controls['agreement'].setValue('true');
      } else {
        this.formPOEInformation.controls['agreement'].setValue('false');
      }

      this.formPOEInformation.patchValue({
        scheduledActivityDate: scheduledActivityDate,
        expectedPOEDate: expectedPoedate,
        workshopCompletionDate: workshopCompletionDate,
        tWACustomerSuccessSolutionPlanDateReceived:
          customerSuccessSolutionPlanDateReceivedTwaonly,
        tWAReportandRecommendationsreportDateReceived:
          twareportAndRecommendationsReportDateReceived,
        customerPostassessmentSurveyDateReceived:
          customerPostAssessmentSurveyDateReceived,
        pOECompletionDate: poecompletionDate,
        engagementCompletionDate: engagementCompletionDateDateCustomerSignedPoe,
        sWSecurityStrategyReportDateReceived: securityStrategyReportSwonly,
        partnerDeliveryContact: result.partnerDeliveryContactPartnerDomain,
        partnerDeliveryContactEmail:
          result.partnerDeliveryContactEmailPartnerDomain,
        customerContactName: result.customerContactNameCustomerDomain,
        customerContactEmail: result.customerContactEmailCustomerDomain,
        statementNumber: result.statementNumber,
        mSInvoiceNumber: result.msinvoiceNumberPmodomain,
        mSInvoicePaidDate: msinvoiceDate,
        paymentCentralTransactionID:
          result.paymentCentralTransactionIdpmodomain,
        supplierID: result.supplierID,
        payeeID: result.payeeID,
        payeeName: result.payeeName,
        submittedDate: SubmittedDate,
        partnerStatementSentDate: PartnerStatementSentDate,
        milestoneOneCompletedDate: milestoneOneCompletedDate
      });
    });
  }

  cancelPoeSurvey(id: number) {
    this.msgsPoeSurvey = [];
    this.osmEdit.getFactDataByRequestDetailsById(id).subscribe(result => {
      const datePipe = new DatePipe('en-US');
      const poecompletionDate = datePipe.transform(
        result.poeCompletionDate,
        'MM/dd/yyyy'
      );
      this.formPOEInformation.patchValue({
        pOECompletionDate: poecompletionDate
      });
    });
  }

  CancelPmodetails(id: number) {
    this.msgsPoe = [];
    this.osmEdit.getFactDataByRequestDetailsById(id).subscribe(result => {
      if (
        result.fullyExecutedAndPaidFromTheFy19twaprogramYnfy19paidTwa === true
      ) {
        this.formInternalPMO.controls[
          'fullyexecutedandpaidfromtheFY19TWAProgramYN'
        ].setValue('true');
      } else {
        this.formInternalPMO.controls[
          'fullyexecutedandpaidfromtheFY19TWAProgramYN'
        ].setValue('false');
      }

      if (
        result.fullyExecutedAndPaidFromTheFy19mdaprogramYnfy19paidMda === true
      ) {
        this.formInternalPMO.controls[
          'fullyexecutedandpaidfromtheFY19MDAProgramYN'
        ].setValue('true');
      } else {
        this.formInternalPMO.controls[
          'fullyexecutedandpaidfromtheFY19MDAProgramYN'
        ].setValue('false');
      }

      if (
        result.partnerRequestedSameTenantIdynduplicateTenantFromSamePartner ===
        true
      ) {
        this.formInternalPMO.controls[
          'partnerRequestedsameTenantIDYN'
        ].setValue('true');
      } else {
        this.formInternalPMO.controls[
          'partnerRequestedsameTenantIDYN'
        ].setValue('false');
      }

      if (
        result.anotherPartnerRequestedSameTenantIdynduplicateTenantFromAnotherPartner ===
        true
      ) {
        this.formInternalPMO.controls[
          'anotherPartnerRequestedSameTenantID'
        ].setValue('true');
      } else {
        this.formInternalPMO.controls[
          'anotherPartnerRequestedSameTenantID'
        ].setValue('false');
      }

      if (result.c3customerYn === true) {
        this.formInternalPMO.controls['C3SWPartner'].setValue('true');
      } else {
        this.formInternalPMO.controls['C3SWPartner'].setValue('false');
      }
      if (result.c3TWAPartnerYN === true) {
        this.formInternalPMO.controls['C3TWAPartner'].setValue('true');
      } else {
        this.formInternalPMO.controls['C3TWAPartner'].setValue('false');
      }

      this.formInternalPMO.patchValue({
        fullyexecutedandpaidfromtheFY19TWAProgramYNrequestIds:
          result.fullyExecutedAndPaidFromTheFY19TWAProgramYNFY19PaidTWARequestIds,
        fullyexecutedandpaidfromtheFY19MDAProgramYNrequestIds:
          result.fullyExecutedAndPaidFromTheFY19MDAProgramYNFY19PaidMDARequestIds,
        partnerRequestedsameTenantIDYNrequestIds:
          result.partnerRequestedSameTenantIDYNDuplicateTenantFromSamePartnerRequestIds,
        anotherPartnerRequestedSameTenantIDMpnids:
          result.anotherPartnerRequestedSameTenantIDYNDuplicateTenantFromAnotherPartnerMPNIDS
      });
    });
    this.isReadonlyIntPMO = true;
  }

  editCustomer() {
    this.isReadonlycust = false;
    this.custbtnNav = true;
    this.formCustomer.enable();
  }

  editInternalPMO() {
    this.isReadonlyIntPMO = false;
    this.intPMObtnNav = true;
    this.formInternalPMO.enable();
  }

  editPoeInformation() {
    this.isReadonlyPOE = false;
    this.btnNavPoe = true;
    this.formPOEInformation.enable();
  }

  editPoeSurvey() {
    this.isReadonlyPOESurvey = false;
    this.btnNavPoeSurvey = true;
    this.formPOESurvey.enable();
  }

  editEngagementDetails() {
    this.isReadonlyEng = false;
    this.btnNavEngDetails = true;
    this.formEngagement.enable();
  }

  cusSurveyResponse() {
    this.isCusSurveyResponse = !this.isCusSurveyResponse;
  }

  parSurveyResponse() {
    this.isParSurveyResponse = !this.isParSurveyResponse;
  }
  getPartnerTypeList() {
    this.osmEdit.getPartnerTypeDropDown().subscribe(PTList => {
      this.partnertypes = PTList;
    });
  }

  ChangeEngagementTypeDropdown() {
    this.osmEdit
      .ChangeEngagementTypeDropdown(
        this.engementId,
        this.settingsServices.AliasName || ''
      )
      .subscribe(ddList => {
        this.changeEngType = ddList;
        if (
          this.changeEngType.find(e => e.engagementName == null) ||
          this.changeEngType.find(e => e.engagementType == null)
        ) {
          this.changeEng = true;
        } else {
          this.changeEng = false;
        }
      });
  }

  getTaskOwnerList() {
    this.osmEdit.getTaskOwnerDropDown().subscribe(PTList => {
      this.taskOwnerDrpdwn = PTList;
    });
  }

  getPmoStatusList() {
    this.osmEdit.getPmoStatusDropDown().subscribe(PTList => {
      this.pmoStatus = PTList;
    });
  }

  getPMONextStepsDropDown() {
    this.osmEdit.getPMONextStepsForSiDropDown().subscribe(PTList => {
      if (this.isGsiWorkshop) {
        this.pmoNextStepStatus = PTList;
      } else {
        this.filterPmoNextStepDropdown(PTList);
      }
    });
  }

  filterPmoNextStepDropdown(PTList) {
    this.pmoNextStepStatus = PTList.filter(item => {
      return (
        item.pmoNextStepName !== PmoNextStepStatus.Validate_Opportunity_Size
      );
    });
  }

  filterL2InternalStatusList(PTList: L2InternalStatus[]) {
    this.l2InternalStatus1 = PTList.filter(item => {
      return item.l2internalStatus !== OpsStatus.Validate_MSX_ID;
    });
  }

  getODimIncentiveDropDown() {
    this.osmEdit.getODimIncentiveDropDown().subscribe(oDimIncentiveList => {
      this.ODimIncentive = oDimIncentiveList;
    });
  }

  getL1InternalStatusList() {
    this.osmEdit.getL1InternalStatusForSiDropDown().subscribe(PTList => {
      this.l1InternalStatus1 = PTList;
    });
  }

  getL2InternalStatusList() {
    this.osmEdit.getL2InternalStatusForSiDropDown().subscribe(PTList => {
      if (this.isGsiWorkshop) {
        this.l2InternalStatus1 = PTList;
      } else {
        this.filterL2InternalStatusList(PTList);
      }
    });
  }

  getMilestonePaymentStatus() {
    this.osmEdit.getMilestonePaymentStatus().subscribe(PTList => {
      this.milestonePaymentStatuses = PTList;
    });
  }

  getDeclineReasonList() {
    this.osmEdit.getDeclineReasonDropDown().subscribe(PTList => {
      this.declineReason = PTList;
    });
  }

  getAllEngagementType() {
    this.osmEdit.getEngagementTypeDropDown().subscribe(PTList => {
      this.engagementType1 = PTList;
    });
  }

  getEngagementType(engagementName, strEngagementType) {
    if (this.engagementType1 != undefined) {
      if (this.engagementType1 && this.engagementType1.length == 0) {
        this.osmEdit.getEngagementTypeDropDown().subscribe(PTList => {
          this.engagementType1 = PTList.filter(
            x => x.engagementName === engagementName
          );
          const engagementType = this.engagementType1.filter(
            f => f.engagementType == strEngagementType
          );
          this.formPOEInformation.controls['workshopTypeCompleted'].setValue(
            engagementType[0]
          );
        });
      } else {
        this.engagementType1 = this.engagementType1.filter(
          x => x.engagementName === engagementName
        );
        const engagementType = this.engagementType1.filter(
          f => f.engagementType == strEngagementType
        );
        this.formPOEInformation.controls['workshopTypeCompleted'].setValue(
          engagementType[0]
        );
      }
    } else {
      this.osmEdit.getEngagementTypeDropDown().subscribe(PTList => {
        this.engagementType1 = PTList.filter(
          x => x.engagementName === engagementName
        );
        const engagementType = this.engagementType1.filter(
          f => f.engagementType == strEngagementType
        );
        this.formPOEInformation.controls['workshopTypeCompleted'].setValue(
          engagementType[0]
        );
      });
    }
  }

  getPoeStatus() {
    this.osmEdit.getPoeStatusDropDown().subscribe(PTList => {
      this.poeStatus = PTList;
    });
  }

  getCusPoeSurveyResponse(id) {
    this.osmEdit
      .getPoeSurveyResponse(id.toString(), 'Customer', 'Satisfaction Survey')
      .subscribe(surResult => {
        if (surResult) {
          this.cusPoeSurveyResponse = surResult.poeSurveyResponses;
          this.cusSurveyRejectionReason = surResult.documentRejectionReasons;
          this.customerSurveyRejectionReason = this.getReasons(
            this.cusSurveyRejectionReason
          );
        } else {
          this.cusPoeSurveyResponse = [];
          this.cusSurveyRejectionReason = [];
          this.customerSurveyRejectionReason = '';
        }
      });
  }

  getParPoeSurveyResponse(id) {
    this.osmEdit
      .getPoeSurveyResponse(id.toString(), 'Partner', 'Findings Survey')
      .subscribe(surResult => {
        this.parPoeSurveyResponse = surResult
          ? surResult.poeSurveyResponses
          : [];
      });
  }

  getExpectedPaymentMonth() {
    this.osmEdit.getExpectedPaymentMonthDropDown().subscribe(PTList => {
      this.monthList = PTList;
    });
  }

  getConfidence() {
    this.osmEdit.getConfidenceDropDown().subscribe(PTList => {
      this.confidence = PTList;
    });
  }

  getPOESurveyStatus() {
    this.osmEdit.getPoeSurveyStatusDropDown().subscribe(PTList => {
      this.partnerPOESurveyStatus = PTList;
    });

    this.osmEdit.getPoeDocStatusDropDown().subscribe(PTList => {
      this.pOEDOCstatus1 = PTList;
    });
  }

  getPoeInvoiceStatusDropDown() {
    this.osmEdit.getPoeInvoiceStatusDropDown().subscribe(PTList => {
      this.PoeInvoiceStatus = PTList;
    });
  }

  closeSidebar() {
    this.localStorage.setFullscreenMode(this.isFullScreen);
    this.umsgs = [];
    this.chngmsg = [];
    this.partnermsgs = [];
    this.custmsgs = [];
    this.intpmomsgs = [];
    this.msgsEngDetails = [];
    this.msgsPoe = [];
    this.msgsPoeSurvey = [];
    this.msgsUsageDetails = [];
    this.isReadonlyUsage = true;
    this.isReadonlyChaneEng = true;
    this.isReadonlypart = true;
    this.isReadonlycust = true;
    this.isReadonlyIntPMO = true;
    this.isReadonlyEng = true;
    this.isReadonlyPOE = true;
    this.partbtnNav = false;
    this.custbtnNav = false;
    this.intPMObtnNav = false;
    this.engBtnNav = false;
    this.btnNavPoe = false;
    this.loadcustomAck = false;
    this.btnNavEngDetails = false;
    this.btnDisable = false;
    this.transactionSpin = false;
    this.selectedEngType = null;
    this.selectedEngName = null;
    this.changeEngDropdown = [];
    this.changeEngName = [];
    this.changeEngType = [];
    this.filesUpload = [];
    this.closeEditSidebar.emit(false);
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  openAccordion() {
    this.index = this.lastIndex++;
  }

  closeAccordion() {
    this.index = this.lastIndex--;
  }

  getPartnerPaymentDetails(input: CommonInputModel) {
    this.ds
      .getPartnerAndPaymentDetails(input)
      .subscribe(partnerPaymentDetails => {
        this.partnerPaymentDetails = partnerPaymentDetails;

        this.partnerPaymentDetails.paymentProfileStatusDescription =
          this.partnerPaymentDetails.paymentProfileStatusDescription != null
            ? this.partnerPaymentDetails.paymentProfileStatusDescription
            : PaymentProfileStatus.Missing;

        this.partnerPaymentDetails.contractStatus =
          this.partnerPaymentDetails.programAgreementStatus !== null &&
          this.partnerPaymentDetails.programAgreementStatus === true
            ? this.partnerPaymentDetails.programAgreementStatus.toString()
            : '';

        this.computePayeeContactName();
      });
  }

  computePayeeContactName() {
    if (
      this.partnerPaymentDetails &&
      this.partnerPaymentDetails.paymentProfileInfo
    ) {
      const firstName =
        this.partnerPaymentDetails.paymentProfileInfo.payeeFirstName || '';

      const lastname =
        this.partnerPaymentDetails.paymentProfileInfo.payeeLastName || '';

      if (this.isValidName(firstName) && this.isValidName(lastname)) {
        this.payeeContactName = firstName + ' ' + lastname;
      } else if (this.isValidName(firstName)) {
        this.payeeContactName = firstName;
      } else if (this.isValidName(lastname)) {
        this.payeeContactName = lastname;
      } else {
        this.payeeContactName = 'NA';
      }
    } else {
      this.payeeContactName = 'NA';
    }
  }

  private isValidName(value: string): boolean {
    return value !== null && value !== 'NA';
  }

  get PaymentProfileStatus(): typeof PaymentProfileStatus {
    return PaymentProfileStatus;
  }

  get incentiveEligible(): boolean {
    return (
      this.engagementRequestedDate >= Constants.incentiveSupportStartDate &&
      typeof this.customerCountry === 'string' &&
      this.customerCountry.toLowerCase() ===
        Constants.incentiveRequiredLocation.toLowerCase() &&
      typeof this.partnerLocation === 'string' &&
      this.partnerLocation.toLowerCase() ===
        Constants.incentiveRequiredLocation.toLowerCase()
    );
  }

  reviewPoeInvoice(event?: boolean) {
    if (event) {
      this.formPOESurvey.controls['poeInvoicestatus'].setValue({
        poeInvoiceStatusID: 5,
        poeInvoiceStatusName: 'Completed'
      });
    } else {
      this.formPOESurvey.controls['poeInvoicestatus'].setValue({
        poeInvoiceStatusID: 4,
        poeInvoiceStatusName: 'Rejected'
      });
    }
    this.refreshNotes();
  }

  reviewCustomerAck(event?: boolean) {
    if (event) {
      this.formEngagement.controls['taskOwner'].setValue({
        taskOwnerId: 13,
        taskOwner: 'No Action'
      });

      this.formEngagement.controls['t1InternalStatus'].setValue({
        l1internalStatusId: 4,
        l1internalStatus: 'Committed'
      });

      this.formEngagement.controls['opsStatus'].setValue({
        l2internalStatusId: 8,
        l2internalStatus: 'Notify the partner'
      });

      this.formEngagement.controls['pMONextSteps'].setValue({
        pmonextStepId: 4,
        pmoNextStepName: 'Send Email'
      });
      let committedDate = this.datePipe.transform(
        this.formEngagement.controls['committedDate'].value,
        'MM/dd/yyyy'
      );
      if (!committedDate) {
        committedDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy');
        this.formEngagement.controls['committedDate'].setValue(committedDate);
      }
      this.formEngagementDetails.controls['enagementStatus'].setValue(
        'Approved'
      );
    } else {
      this.formEngagement.controls['opsStatus'].setValue({
        l2internalStatusId: 13,
        l2internalStatus: 'Waiting for customer acknowledgement'
      });
    }
    this.refreshNotes();
  }

  reviewPoeDocument(event?: boolean) {
    if (event) {
      this.formPOESurvey.controls['poeDOCstatusCn'].setValue({
        poeDocStatusId: 5,
        poeDocStatusName: 'Completed'
      });
    } else {
      this.formPOESurvey.controls['poeDOCstatusCn'].setValue({
        poeDocStatusId: 4,
        poeDocStatusName: 'Rejected'
      });
    }
    this.refreshNotes();
  }

  checkDocumentType(documentTypeId: number) {
    if (documentTypeId === DocumentsType.POEInvoice) {
      return Constants.poeDocumentType[0].type;
    } else if (documentTypeId === DocumentsType.POEDocument) {
      return Constants.poeDocumentType[1].type;
    }
    return null;
  }

  checkPoeDocumentType(documentName: string) {
    if (documentName === this.invoiceDocument) {
      return Constants.poeDocumentType[0].type;
    } else {
      return Constants.poeDocumentType[1].type;
    }
  }

  refreshAdditionalDocument(event?: boolean) {
    if (event) {
      this.getUploadedAdditionalDocs_ByEngagementId(this.engementId);
      this.getPOEDocumentHistory(this.engementId);
    } else {
      this.getUploadedPOEDocs_ByEngagementId(this.engementId);
    }
  }

  getReasons(reasons: DocumentDeclineReason[]) {
    return reasons ? reasons.map(s => s.reason).join(', ') : '';
  }

  onPoeDocumentUploadClick(documentType: number) {
    this.docType = documentType;
    this.loadcustomAck = true;
  }

  uploadPOEDocumentToBlob(event) {
    if (event.lenght > this.poeDocMaximumFiles) {
      this.umsgs = [];
      this.umsgs.push({
        severity: 'error',
        detail: 'Multiple files are not allowed to upload'
      });
      this.clearHtmlFileInput();
    } else {
      const fileUpload = event[0] as File;
      if (this.isValidFileSize(fileUpload)) {
        const formData = new FormData();
        formData.append('file', fileUpload, fileUpload.name);
        const newFile: PoeDocument = {
          fileName: fileUpload.name,
          size: fileUpload.size,
          requestDetailId: 0,
          engagementId: 0,
          documentType: 0,
          documentTypeId: 0,
          filePath: '',
          FileURL: ''
        };
        formData.append('documentType', this.docType.toString());
        if (
          this.filesUpload.find(a => a.fileName === newFile.fileName) ===
          undefined
        ) {
          if (this.filesUpload.length === 0 || this.filesUpload.length !== 1) {
            this.filesUpload.push(newFile);
            this.fileUploadSpinners.push(true);
            this.uploadPOEDocToBlob(formData);
            this.transactionSpin = true;
          } else {
            this.umsgs = [];
            this.umsgs.push({
              severity: 'error',
              detail: 'Possible upload only one file in list'
            });
            setTimeout(() => {
              this.umsgs = [];
            }, 6000);
          }
        } else {
          this.umsgs = [];
          this.umsgs.push({
            severity: 'error',
            detail: fileUpload.name + ' file already exits in list'
          });
          setTimeout(() => {
            this.umsgs = [];
          }, 6000);
        }
      }
    }
  }

  private clearHtmlFileInput() {
    this.myfileInput.nativeElement.value = '';
  }

  private isValidFileSize(file: File): boolean {
    const fileSizeinMB = file.size / (1024 * 1000);
    const size = Math.round(fileSizeinMB * 100) / 100;

    if (size > 10) {
      this.umsgs = [];
      this.umsgs.push({
        severity: 'error',
        detail:
          'Error (File Size): ' +
          file.name +
          ': exceed file size limit of 10 MB '
      });
      setTimeout(() => {
        this.umsgs = [];
      }, 6000);
      this.clearHtmlFileInput();
      return false;
    }

    return true;
  }

  submitUploadedPOEDocuments() {
    const poeDocument: PoeDocument = {
      documentType: this.docType,
      requestDetailId: this.engementId,
      fileName: this.storeCustAckFile.fileName || '',
      filePath: this.storeCustAckFile.url || '',
      engagementId: 0,
      documentTypeId: 0,
      FileURL: ''
    };

    this.osmEdit.submitUploadedPOEDocuments(poeDocument).subscribe(
      () => {
        this.cancelCustomAckNav();
        this.reloadEngagementDetails();
      },
      error => {
        if (error.status === 500) {
          this.umsgs = [];
          this.umsgs.push({ severity: 'error', detail: error.error.errorInfo });
          setTimeout(() => {
            this.umsgs = [];
          }, 2000);
        } else {
          this.umsgs = [];
          this.umsgs.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured'
          });
        }
      }
    );
  }

  uploadPOEDocToBlob(formData: any) {
    this.osmEdit.uploadPOEDocToBlob(formData, this.engementId).subscribe(
      (efRes: any) => {
        this.storeCustAckFile = efRes;
        const finalFile = this.filesUpload.find(
          a => a.fileName === efRes.fileName
        );
        const idx = this.filesUpload.indexOf(finalFile);
        this.fileUploadSpinners[idx] = false;
        if (++this.loadingCount === this.filesUpload.length) {
          this.transactionSpin = false;
        }
      },
      error => {
        this.umsgs = [];
        if (error.status === 500) {
          this.umsgs.push({ severity: 'error', detail: error.statusText });
          setTimeout(() => {
            this.umsgs = [];
          }, 4000);
        } else if (error.status === 502) {
          this.umsgs.push({ severity: 'error', detail: error.statusText });
          setTimeout(() => {
            this.umsgs = [];
          }, 4000);
        } else {
          this.umsgs.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured while uploading a file'
          });
          this.filesUpload = [];
          this.fileUploadSpinners = [];
          this.transactionSpin = false;
          setTimeout(() => {
            this.umsgs = [];
          }, 4000);
        }
      }
    );
  }

  get documentType(): typeof DocumentsType {
    return DocumentsType;
  }

  get fileUploadHeader(): string {
    if (this.docType === DocumentsType.CustomerAcknowledgement) {
      return 'Upload Customer Acknowledgement';
    } else if (this.docType === DocumentsType.POEInvoice) {
      return 'Upload POE Invoice';
    } else if (this.docType === DocumentsType.POEDocument) {
      return 'Upload Findings and Recommendation';
    }
    return '';
  }
  get showUploadedFiles() {
    return (
      this.docType !== DocumentsType.POEInvoice &&
      this.docType !== DocumentsType.POEDocument
    );
  }

  reloadEngagementDetails() {
    this.getPOEDocumentHistory(this.engementId);
    this.getUploadedPOEDocs_ByEngagementId(this.engementId);
    this.getDetails(this.engementId);
  }

  get canShowCustomerSurveyRejection(): boolean {
    return (
      this.customerSurveyRejectionReason &&
      this.formPOESurvey.controls['customerPOESurveyStatus'] &&
      this.formPOESurvey.controls['customerPOESurveyStatus'].value &&
      this.formPOESurvey.controls['customerPOESurveyStatus'].value
        .poeSurveyStatusName == 'Rejected'
    );
  }

  get engagementTitle() {
    if (this.programTypeId === ProgramTypes.Accelerator) {
      return 'Enagagement';
    } else if (
      this.programTypeId === ProgramTypes.MSSP ||
      this.programTypeId === ProgramTypes.Operator
    ) {
      return 'Special Investments';
    }
    return '';
  }

  get ProgramType() {
    return ProgramTypes;
  }

  get paymentInfoTitle() {
    if (this.programTypeId === ProgramTypes.Accelerator) {
      return 'Engagement Payment Information';
    } else if (
      this.programTypeId === ProgramTypes.MSSP ||
      this.programTypeId === ProgramTypes.Operator
    ) {
      return 'Activity Payment Information';
    }
    return '';
  }

  get workshopDate_Label() {
    if (this.programTypeId === ProgramTypes.Accelerator) {
      return 'Workshop Completion Date';
    } else if (
      this.programTypeId === ProgramTypes.MSSP ||
      this.programTypeId === ProgramTypes.Operator
    ) {
      return 'Pre-Sales Activity Date';
    }
    return '';
  }

  get invoiceNumber_Label() {
    if (this.programTypeId === ProgramTypes.Accelerator) {
      return 'MS Invoice Number';
    } else if (
      this.programTypeId === ProgramTypes.MSSP ||
      this.programTypeId === ProgramTypes.Operator
    ) {
      return 'Milestone 1 MS Invoice Number';
    }
    return '';
  }

  get invoicePaidDate_Label() {
    if (this.programTypeId === ProgramTypes.Accelerator) {
      return 'MS Invoice Paid Date';
    } else if (
      this.programTypeId === ProgramTypes.MSSP ||
      this.programTypeId === ProgramTypes.Operator
    ) {
      return 'Milestone 1 MS Invoice Paid Date';
    }
    return '';
  }

  get transactionId_Label() {
    if (this.programTypeId === ProgramTypes.Accelerator) {
      return 'Payment Central Transaction ID';
    } else if (
      this.programTypeId === ProgramTypes.MSSP ||
      this.programTypeId === ProgramTypes.Operator
    ) {
      return 'Milestone 1 Payment Central Transaction ID';
    }
    return '';
  }

  get isSpecialInvestments() {
    if (
      this.programTypeId === ProgramTypes.MSSP ||
      this.programTypeId === ProgramTypes.Operator
    ) {
      return true;
    }
    return false;
  }

  get isCSIEngagement() {
    if (this.programTypeId === ProgramTypes.MSSP) {
      return true;
    }
    return false;
  }

  get workshopTypeCompleted_Label() {
    if (this.programTypeId === ProgramTypes.Accelerator) {
      return 'Workshop Type Completed';
    } else if (
      this.programTypeId === ProgramTypes.MSSP ||
      this.programTypeId === ProgramTypes.Operator
    ) {
      return 'Activity Completed';
    }
    return '';
  }

  get showCustomerAckRejectedReason() {
    return (
      this.formEngagement.controls['customerAckStatus'].value ===
      CustomerAcknowledgementDocumentStatus.Rejected
    );
  }
  onCheckedEngagementExtended() {
    this.isEngagementExtendedEnable =
      !this.formEngagement.controls['isExtended'].value;
  }

  getStyleForPaymentProfileStatus(status: string) {
    return this.paymentprofileService.getStyleForPaymentProfileStatus(status);
  }

  getPaymentProfileStatus(status: string) {
    return this.paymentprofileService.getPaymentProfileStatus(status);
  }

  get hasCustomerAcknowledgement() {
    return this.formEngagement.controls['hasCustomerAcknowledgement'].value;
  }
}
